//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AccountingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    getPayrollBatch(batchId: number): Observable<PayrollBatch> {
        let url_ = this.baseUrl + "/api/accounting/payrollbatch/{batchId}";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayrollBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayrollBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollBatch>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollBatch>;
        }));
    }

    protected processGetPayrollBatch(response: HttpResponseBase): Observable<PayrollBatch> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayrollBatch;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayrollBatch>(null as any);
    }

    /**
     * @return No Content
     */
    deletePayrollBatch(batchId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounting/payrollbatch/{batchId}";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePayrollBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePayrollBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePayrollBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getPastPayrollBatches(args: PayrollBatchListArgs): Observable<PagedResultsOfPayrollBatchGroup> {
        let url_ = this.baseUrl + "/api/accounting/payrollbatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPastPayrollBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPastPayrollBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfPayrollBatchGroup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfPayrollBatchGroup>;
        }));
    }

    protected processGetPastPayrollBatches(response: HttpResponseBase): Observable<PagedResultsOfPayrollBatchGroup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfPayrollBatchGroup;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfPayrollBatchGroup>(null as any);
    }

    /**
     * @return OK
     */
    getPaycheckCandidate(paycheckId: number): Observable<PaycheckCandidate> {
        let url_ = this.baseUrl + "/api/accounting/paycheck/{paycheckId}";
        if (paycheckId === undefined || paycheckId === null)
            throw new Error("The parameter 'paycheckId' must be defined.");
        url_ = url_.replace("{paycheckId}", encodeURIComponent("" + paycheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaycheckCandidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaycheckCandidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaycheckCandidate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaycheckCandidate>;
        }));
    }

    protected processGetPaycheckCandidate(response: HttpResponseBase): Observable<PaycheckCandidate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaycheckCandidate;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaycheckCandidate>(null as any);
    }

    /**
     * @return OK
     */
    getPaycheckCandidates(args: PaycheckCandidateListArgs): Observable<PagedResultsOfPaycheckCandidateSummary> {
        let url_ = this.baseUrl + "/api/accounting/paycheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaycheckCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaycheckCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfPaycheckCandidateSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfPaycheckCandidateSummary>;
        }));
    }

    protected processGetPaycheckCandidates(response: HttpResponseBase): Observable<PagedResultsOfPaycheckCandidateSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfPaycheckCandidateSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfPaycheckCandidateSummary>(null as any);
    }

    /**
     * @return OK
     */
    getPendingDwrsForPayrollBatch(forDate: string, payrollType: PayrollType): Observable<DwrFormSummary[]> {
        let url_ = this.baseUrl + "/api/accounting/nonpayabledwrs?";
        if (forDate === undefined || forDate === null)
            throw new Error("The parameter 'forDate' must be defined and cannot be null.");
        else
            url_ += "forDate=" + encodeURIComponent("" + forDate) + "&";
        if (payrollType === undefined || payrollType === null)
            throw new Error("The parameter 'payrollType' must be defined and cannot be null.");
        else
            url_ += "payrollType=" + encodeURIComponent("" + payrollType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingDwrsForPayrollBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingDwrsForPayrollBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DwrFormSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DwrFormSummary[]>;
        }));
    }

    protected processGetPendingDwrsForPayrollBatch(response: HttpResponseBase): Observable<DwrFormSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DwrFormSummary[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DwrFormSummary[]>(null as any);
    }

    /**
     * @return OK
     */
    getCurrentBatchGroup(): Observable<PayrollBatchGroup> {
        let url_ = this.baseUrl + "/api/accounting/currentbatchgroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentBatchGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentBatchGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollBatchGroup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollBatchGroup>;
        }));
    }

    protected processGetCurrentBatchGroup(response: HttpResponseBase): Observable<PayrollBatchGroup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayrollBatchGroup;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayrollBatchGroup>(null as any);
    }

    /**
     * @return OK
     */
    getFreshPayrollBatch(request: PayrollBatchRefreshRequest): Observable<PayrollBatchSummary> {
        let url_ = this.baseUrl + "/api/accounting/refreshpayrollbatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFreshPayrollBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFreshPayrollBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollBatchSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollBatchSummary>;
        }));
    }

    protected processGetFreshPayrollBatch(response: HttpResponseBase): Observable<PayrollBatchSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayrollBatchSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayrollBatchSummary>(null as any);
    }

    /**
     * @return OK
     */
    getPayrollBatchSummary(batchId: number): Observable<PayrollBatchSummary> {
        let url_ = this.baseUrl + "/api/accounting/getpayrollbatchsummary/{batchId}";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayrollBatchSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayrollBatchSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollBatchSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollBatchSummary>;
        }));
    }

    protected processGetPayrollBatchSummary(response: HttpResponseBase): Observable<PayrollBatchSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayrollBatchSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayrollBatchSummary>(null as any);
    }

    /**
     * @return No Content
     */
    deletePayrollBatches(forDate: string): Observable<void> {
        let url_ = this.baseUrl + "/api/accounting/payrollbatches/{forDate}";
        if (forDate === undefined || forDate === null)
            throw new Error("The parameter 'forDate' must be defined.");
        url_ = url_.replace("{forDate}", encodeURIComponent("" + forDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePayrollBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePayrollBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePayrollBatches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    submitPayrollBatch(batchId: number): Observable<PayrollBatchSummary> {
        let url_ = this.baseUrl + "/api/accounting/submitpayrollbatch/{batchId}";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitPayrollBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitPayrollBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollBatchSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollBatchSummary>;
        }));
    }

    protected processSubmitPayrollBatch(response: HttpResponseBase): Observable<PayrollBatchSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayrollBatchSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayrollBatchSummary>(null as any);
    }

    /**
     * @return No Content
     */
    resendPayrollBatchReports(batchId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounting/payrollbatchreports/{batchId}";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendPayrollBatchReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendPayrollBatchReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendPayrollBatchReports(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getInvoiceCandidates(args: InvoiceCandidateListArgs): Observable<PagedResultsOfInvoiceCandidateSummary> {
        let url_ = this.baseUrl + "/api/accounting/invoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfInvoiceCandidateSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfInvoiceCandidateSummary>;
        }));
    }

    protected processGetInvoiceCandidates(response: HttpResponseBase): Observable<PagedResultsOfInvoiceCandidateSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfInvoiceCandidateSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfInvoiceCandidateSummary>(null as any);
    }

    /**
     * @return OK
     */
    createNewInvoiceCandidate(request: InvoiceWithCutoffRequest): Observable<InvoiceCandidate> {
        let url_ = this.baseUrl + "/api/accounting/newinvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewInvoiceCandidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewInvoiceCandidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceCandidate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceCandidate>;
        }));
    }

    protected processCreateNewInvoiceCandidate(response: HttpResponseBase): Observable<InvoiceCandidate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvoiceCandidate;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceCandidate>(null as any);
    }

    /**
     * @return OK
     */
    getUtilityCoverSheetInvoicingStatus(invoiceCandidate: InvoiceCandidate): Observable<UtilityCoverSheetStatusResponse> {
        let url_ = this.baseUrl + "/api/accounting/utilitycoversheetstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoiceCandidate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityCoverSheetInvoicingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityCoverSheetInvoicingStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtilityCoverSheetStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtilityCoverSheetStatusResponse>;
        }));
    }

    protected processGetUtilityCoverSheetInvoicingStatus(response: HttpResponseBase): Observable<UtilityCoverSheetStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UtilityCoverSheetStatusResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UtilityCoverSheetStatusResponse>(null as any);
    }

    /**
     * @return No Content
     */
    saveOtherChargeItem(request: OtherChargeItem): Observable<void> {
        let url_ = this.baseUrl + "/api/accounting/saveotherchargeitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveOtherChargeItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveOtherChargeItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveOtherChargeItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getOtherChargeItem(jobId: number): Observable<OtherChargeItem[]> {
        let url_ = this.baseUrl + "/api/accounting/getotherchargeitems/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOtherChargeItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOtherChargeItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OtherChargeItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OtherChargeItem[]>;
        }));
    }

    protected processGetOtherChargeItem(response: HttpResponseBase): Observable<OtherChargeItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OtherChargeItem[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OtherChargeItem[]>(null as any);
    }

    /**
     * @return No Content
     */
    deleteOtherChargeItem(otherChargeItemId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/accounting/deleteotherchargeitems/{otherChargeItemId}";
        if (otherChargeItemId === undefined || otherChargeItemId === null)
            throw new Error("The parameter 'otherChargeItemId' must be defined.");
        url_ = url_.replace("{otherChargeItemId}", encodeURIComponent("" + otherChargeItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOtherChargeItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOtherChargeItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOtherChargeItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getInvoiceCandidate(invoiceId: number): Observable<InvoiceCandidate> {
        let url_ = this.baseUrl + "/api/accounting/invoice/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceCandidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceCandidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceCandidate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceCandidate>;
        }));
    }

    protected processGetInvoiceCandidate(response: HttpResponseBase): Observable<InvoiceCandidate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvoiceCandidate;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceCandidate>(null as any);
    }

    /**
     * @return OK
     */
    submitInvoiceCandidate(invoice: InvoiceCandidate): Observable<number> {
        let url_ = this.baseUrl + "/api/accounting/submitinvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoice);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitInvoiceCandidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitInvoiceCandidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSubmitInvoiceCandidate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    version(): Observable<AppInfoModel> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppInfoModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppInfoModel>;
        }));
    }

    protected processVersion(response: HttpResponseBase): Observable<AppInfoModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppInfoModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppInfoModel>(null as any);
    }

    /**
     * @return OK
     */
    test(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    testAuth(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/test-auth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processTestAuth(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ApiRequestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    getRequests(args: ApiRequestListArgs): Observable<PagedResultsOfApiRequest> {
        let url_ = this.baseUrl + "/api/public";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfApiRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfApiRequest>;
        }));
    }

    protected processGetRequests(response: HttpResponseBase): Observable<PagedResultsOfApiRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfApiRequest;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfApiRequest>(null as any);
    }

    /**
     * @return OK
     */
    saveRequest(request: ApiRequest): Observable<ApiRequest> {
        let url_ = this.baseUrl + "/api/public/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiRequest>;
        }));
    }

    protected processSaveRequest(response: HttpResponseBase): Observable<ApiRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiRequest;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiRequest>(null as any);
    }

    /**
     * @return OK
     */
    getRequest(requestId: number): Observable<ApiRequest> {
        let url_ = this.baseUrl + "/api/public/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiRequest>;
        }));
    }

    protected processGetRequest(response: HttpResponseBase): Observable<ApiRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiRequest;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiRequest>(null as any);
    }

    /**
     * @return OK
     */
    updateFlairDocsJob(jobRequest: FlairDocsJobRequest): Observable<any> {
        let url_ = this.baseUrl + "/api/public/flairdocsjob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFlairDocsJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFlairDocsJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUpdateFlairDocsJob(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    addFlairDocsJob(jobRequest: FlairDocsJobRequest): Observable<any> {
        let url_ = this.baseUrl + "/api/public/flairdocsjob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFlairDocsJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFlairDocsJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAddFlairDocsJob(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    addTravelTime(travelTimeRequest: TravelTime): Observable<any> {
        let url_ = this.baseUrl + "/api/public/travel-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(travelTimeRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTravelTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTravelTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAddTravelTime(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuditTrailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    get(args: AuditTrailListArgs): Observable<PagedResultsOfAuditTrail> {
        let url_ = this.baseUrl + "/api/auditTrails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfAuditTrail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfAuditTrail>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PagedResultsOfAuditTrail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfAuditTrail;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfAuditTrail>(null as any);
    }

    /**
     * @return OK
     */
    getDwrSummaryAuditTrails(args: AuditTrailListArgs): Observable<PagedResultsOfAuditTrail> {
        let url_ = this.baseUrl + "/api/dwrSummaryAuditTrails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwrSummaryAuditTrails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwrSummaryAuditTrails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfAuditTrail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfAuditTrail>;
        }));
    }

    protected processGetDwrSummaryAuditTrails(response: HttpResponseBase): Observable<PagedResultsOfAuditTrail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfAuditTrail;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfAuditTrail>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    getCustomers(args: CustomerListArgs): Observable<PagedResultsOfCustomer> {
        let url_ = this.baseUrl + "/api/customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfCustomer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfCustomer>;
        }));
    }

    protected processGetCustomers(response: HttpResponseBase): Observable<PagedResultsOfCustomer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfCustomer;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfCustomer>(null as any);
    }

    /**
     * @return OK
     */
    getCustomerPickList(searchText: string): Observable<CustomerLink[]> {
        let url_ = this.baseUrl + "/api/customers/{searchText}";
        if (searchText === undefined || searchText === null)
            throw new Error("The parameter 'searchText' must be defined.");
        url_ = url_.replace("{searchText}", encodeURIComponent("" + searchText));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerPickList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerPickList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerLink[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerLink[]>;
        }));
    }

    protected processGetCustomerPickList(response: HttpResponseBase): Observable<CustomerLink[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerLink[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerLink[]>(null as any);
    }

    /**
     * @return OK
     */
    getCustomerLink(customerId: number): Observable<CustomerLink> {
        let url_ = this.baseUrl + "/api/customerLink/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerLink>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerLink>;
        }));
    }

    protected processGetCustomerLink(response: HttpResponseBase): Observable<CustomerLink> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerLink;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerLink>(null as any);
    }

    /**
     * @return OK
     */
    getCustomer(customerId: number): Observable<Customer> {
        let url_ = this.baseUrl + "/api/customer/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Customer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Customer>;
        }));
    }

    protected processGetCustomer(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Customer;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer>(null as any);
    }

    /**
     * @return OK
     */
    saveCustomer(customer: Customer): Observable<number> {
        let url_ = this.baseUrl + "/api/customer/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveCustomer(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    linkFlairDocsCustomerToRailsCustomer(railsCustomerId: number, flairDocsCustomerId: string): Observable<number> {
        let url_ = this.baseUrl + "/api/customer/linkFlairDocsCustomer/{railsCustomerId}/{flairDocsCustomerId}";
        if (railsCustomerId === undefined || railsCustomerId === null)
            throw new Error("The parameter 'railsCustomerId' must be defined.");
        url_ = url_.replace("{railsCustomerId}", encodeURIComponent("" + railsCustomerId));
        if (flairDocsCustomerId === undefined || flairDocsCustomerId === null)
            throw new Error("The parameter 'flairDocsCustomerId' must be defined.");
        url_ = url_.replace("{flairDocsCustomerId}", encodeURIComponent("" + flairDocsCustomerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkFlairDocsCustomerToRailsCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkFlairDocsCustomerToRailsCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processLinkFlairDocsCustomerToRailsCustomer(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    addDocumentToCustomer(request: NewDocumentRequest): Observable<Document> {
        let url_ = this.baseUrl + "/api/customer/newDoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentToCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentToCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document>;
        }));
    }

    protected processAddDocumentToCustomer(response: HttpResponseBase): Observable<Document> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Document;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Document>(null as any);
    }

    /**
     * @return OK
     */
    getDocumentsForCustomer(customerId: number): Observable<Document[]> {
        let url_ = this.baseUrl + "/api/customer/documents/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsForCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsForCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document[]>;
        }));
    }

    protected processGetDocumentsForCustomer(response: HttpResponseBase): Observable<Document[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Document[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Document[]>(null as any);
    }

    /**
     * @return OK
     */
    getCompanyPickList(searchText: string): Observable<Company[]> {
        let url_ = this.baseUrl + "/api/companies/{searchText}";
        if (searchText === undefined || searchText === null)
            throw new Error("The parameter 'searchText' must be defined.");
        url_ = url_.replace("{searchText}", encodeURIComponent("" + searchText));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyPickList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyPickList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Company[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Company[]>;
        }));
    }

    protected processGetCompanyPickList(response: HttpResponseBase): Observable<Company[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Company[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Company[]>(null as any);
    }

    /**
     * @return OK
     */
    getRailroads(args: RailroadListArgs): Observable<PagedResultsOfRailroad> {
        let url_ = this.baseUrl + "/api/railroads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRailroads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRailroads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfRailroad>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfRailroad>;
        }));
    }

    protected processGetRailroads(response: HttpResponseBase): Observable<PagedResultsOfRailroad> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfRailroad;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfRailroad>(null as any);
    }

    /**
     * @return OK
     */
    getRailroad(railroadId: number): Observable<Railroad> {
        let url_ = this.baseUrl + "/api/railroad/{railroadId}";
        if (railroadId === undefined || railroadId === null)
            throw new Error("The parameter 'railroadId' must be defined.");
        url_ = url_.replace("{railroadId}", encodeURIComponent("" + railroadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRailroad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRailroad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Railroad>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Railroad>;
        }));
    }

    protected processGetRailroad(response: HttpResponseBase): Observable<Railroad> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Railroad;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Railroad>(null as any);
    }

    /**
     * @return OK
     */
    saveRailroad(railroad: Railroad): Observable<number> {
        let url_ = this.baseUrl + "/api/railroad/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(railroad);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRailroad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRailroad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveRailroad(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    addDocumentToRailroad(request: NewDocumentRequest): Observable<Document> {
        let url_ = this.baseUrl + "/api/railroad/newDoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentToRailroad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentToRailroad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document>;
        }));
    }

    protected processAddDocumentToRailroad(response: HttpResponseBase): Observable<Document> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Document;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Document>(null as any);
    }

    /**
     * @return OK
     */
    getDocumentsForRailroad(railroadId: number): Observable<Document[]> {
        let url_ = this.baseUrl + "/api/railroad/documents/{railroadId}";
        if (railroadId === undefined || railroadId === null)
            throw new Error("The parameter 'railroadId' must be defined.");
        url_ = url_.replace("{railroadId}", encodeURIComponent("" + railroadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsForRailroad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsForRailroad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document[]>;
        }));
    }

    protected processGetDocumentsForRailroad(response: HttpResponseBase): Observable<Document[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Document[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Document[]>(null as any);
    }

    /**
     * @return OK
     */
    getLogoForRailroad(railroadId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/railroad/logo/{railroadId}";
        if (railroadId === undefined || railroadId === null)
            throw new Error("The parameter 'railroadId' must be defined.");
        url_ = url_.replace("{railroadId}", encodeURIComponent("" + railroadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogoForRailroad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogoForRailroad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLogoForRailroad(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return No Content
     */
    removeLogoFromRailroad(railroadId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/railroad/logo/{railroadId}";
        if (railroadId === undefined || railroadId === null)
            throw new Error("The parameter 'railroadId' must be defined.");
        url_ = url_.replace("{railroadId}", encodeURIComponent("" + railroadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLogoFromRailroad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLogoFromRailroad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveLogoFromRailroad(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getRailroadLogos(): Observable<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/railroad/logos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRailroadLogos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRailroadLogos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: string; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: string; }>;
        }));
    }

    protected processGetRailroadLogos(response: HttpResponseBase): Observable<{ [key: string]: string; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: string; }>(null as any);
    }

    /**
     * @return No Content
     */
    updateLogoForRailroad(request: NewDocumentRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/railroad/logo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogoForRailroad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogoForRailroad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLogoForRailroad(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getRailroadPickList(searchText: string): Observable<RailroadLink[]> {
        let url_ = this.baseUrl + "/api/railroads/{searchText}";
        if (searchText === undefined || searchText === null)
            throw new Error("The parameter 'searchText' must be defined.");
        url_ = url_.replace("{searchText}", encodeURIComponent("" + searchText));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRailroadPickList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRailroadPickList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RailroadLink[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RailroadLink[]>;
        }));
    }

    protected processGetRailroadPickList(response: HttpResponseBase): Observable<RailroadLink[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RailroadLink[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RailroadLink[]>(null as any);
    }

    /**
     * @return OK
     */
    getQuoteTemplates(railroadId: number): Observable<RailroadQuoteTemplate[]> {
        let url_ = this.baseUrl + "/api/railroad/quoteTemplates/{railroadId}";
        if (railroadId === undefined || railroadId === null)
            throw new Error("The parameter 'railroadId' must be defined.");
        url_ = url_.replace("{railroadId}", encodeURIComponent("" + railroadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuoteTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuoteTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RailroadQuoteTemplate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RailroadQuoteTemplate[]>;
        }));
    }

    protected processGetQuoteTemplates(response: HttpResponseBase): Observable<RailroadQuoteTemplate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RailroadQuoteTemplate[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RailroadQuoteTemplate[]>(null as any);
    }

    /**
     * @return OK
     */
    getRailRoadLink(railroadId: number): Observable<RailroadLink> {
        let url_ = this.baseUrl + "/api/railroadLink/{railroadId}";
        if (railroadId === undefined || railroadId === null)
            throw new Error("The parameter 'railroadId' must be defined.");
        url_ = url_.replace("{railroadId}", encodeURIComponent("" + railroadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRailRoadLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRailRoadLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RailroadLink>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RailroadLink>;
        }));
    }

    protected processGetRailRoadLink(response: HttpResponseBase): Observable<RailroadLink> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RailroadLink;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RailroadLink>(null as any);
    }

    /**
     * @return OK
     */
    getRailRoadLinks(): Observable<RailroadLink[]> {
        let url_ = this.baseUrl + "/api/railroadLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRailRoadLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRailRoadLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RailroadLink[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RailroadLink[]>;
        }));
    }

    protected processGetRailRoadLinks(response: HttpResponseBase): Observable<RailroadLink[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RailroadLink[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RailroadLink[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllDivisions(): Observable<{ [key: string]: Division[]; }> {
        let url_ = this.baseUrl + "/api/divisions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDivisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDivisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: Division[]; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: Division[]; }>;
        }));
    }

    protected processGetAllDivisions(response: HttpResponseBase): Observable<{ [key: string]: Division[]; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: Division[]; };
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: Division[]; }>(null as any);
    }

    /**
     * @return OK
     */
    getDivisionLink(divisionId: number): Observable<DivisionLink> {
        let url_ = this.baseUrl + "/api/divisionLink/{divisionId}";
        if (divisionId === undefined || divisionId === null)
            throw new Error("The parameter 'divisionId' must be defined.");
        url_ = url_.replace("{divisionId}", encodeURIComponent("" + divisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivisionLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivisionLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivisionLink>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivisionLink>;
        }));
    }

    protected processGetDivisionLink(response: HttpResponseBase): Observable<DivisionLink> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DivisionLink;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DivisionLink>(null as any);
    }

    /**
     * @return OK
     */
    getSubdivisionLink(subdivisionId: number): Observable<SubdivisionLink> {
        let url_ = this.baseUrl + "/api/subdivisionLink/{subdivisionId}";
        if (subdivisionId === undefined || subdivisionId === null)
            throw new Error("The parameter 'subdivisionId' must be defined.");
        url_ = url_.replace("{subdivisionId}", encodeURIComponent("" + subdivisionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubdivisionLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubdivisionLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubdivisionLink>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubdivisionLink>;
        }));
    }

    protected processGetSubdivisionLink(response: HttpResponseBase): Observable<SubdivisionLink> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubdivisionLink;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubdivisionLink>(null as any);
    }

    /**
     * @return OK
     */
    getRailroadSubCodes(railroadId: number): Observable<RailroadSubCode[]> {
        let url_ = this.baseUrl + "/api/subcodes/{railroadId}";
        if (railroadId === undefined || railroadId === null)
            throw new Error("The parameter 'railroadId' must be defined.");
        url_ = url_.replace("{railroadId}", encodeURIComponent("" + railroadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRailroadSubCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRailroadSubCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RailroadSubCode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RailroadSubCode[]>;
        }));
    }

    protected processGetRailroadSubCodes(response: HttpResponseBase): Observable<RailroadSubCode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RailroadSubCode[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RailroadSubCode[]>(null as any);
    }

    /**
     * @return OK
     */
    getFieldWorkersPickList(searchText: string): Observable<FieldWorkerLink[]> {
        let url_ = this.baseUrl + "/api/fieldworkers/{searchText}";
        if (searchText === undefined || searchText === null)
            throw new Error("The parameter 'searchText' must be defined.");
        url_ = url_.replace("{searchText}", encodeURIComponent("" + searchText));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldWorkersPickList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldWorkersPickList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldWorkerLink[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldWorkerLink[]>;
        }));
    }

    protected processGetFieldWorkersPickList(response: HttpResponseBase): Observable<FieldWorkerLink[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldWorkerLink[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldWorkerLink[]>(null as any);
    }

    /**
     * @return OK
     */
    getFieldWorkerLink(fieldWorkerId: number): Observable<FieldWorkerLink> {
        let url_ = this.baseUrl + "/api/fieldworkerLink/{fieldWorkerId}";
        if (fieldWorkerId === undefined || fieldWorkerId === null)
            throw new Error("The parameter 'fieldWorkerId' must be defined.");
        url_ = url_.replace("{fieldWorkerId}", encodeURIComponent("" + fieldWorkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldWorkerLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldWorkerLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldWorkerLink>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldWorkerLink>;
        }));
    }

    protected processGetFieldWorkerLink(response: HttpResponseBase): Observable<FieldWorkerLink> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldWorkerLink;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldWorkerLink>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    getBinaryDataForDocument(documentId: number): Observable<ValueTupleOfBinaryAndString> {
        let url_ = this.baseUrl + "/api/docs/doc/data/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBinaryDataForDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBinaryDataForDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueTupleOfBinaryAndString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueTupleOfBinaryAndString>;
        }));
    }

    protected processGetBinaryDataForDocument(response: HttpResponseBase): Observable<ValueTupleOfBinaryAndString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueTupleOfBinaryAndString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValueTupleOfBinaryAndString>(null as any);
    }

    /**
     * @return No Content
     */
    deleteForDocument(documentId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/docs/doc/delete/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteForDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteForDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteForDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getBinaryData(binaryId: number, documentId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/docs/data/{documentId}?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (binaryId === undefined || binaryId === null)
            throw new Error("The parameter 'binaryId' must be defined and cannot be null.");
        else
            url_ += "binaryId=" + encodeURIComponent("" + binaryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBinaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBinaryData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetBinaryData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    getDwrs(args: DwrListArgs): Observable<PagedResultsOfDwrFormSummary> {
        let url_ = this.baseUrl + "/api/forms/dwr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwrs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwrs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfDwrFormSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfDwrFormSummary>;
        }));
    }

    protected processGetDwrs(response: HttpResponseBase): Observable<PagedResultsOfDwrFormSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfDwrFormSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfDwrFormSummary>(null as any);
    }

    /**
     * @return OK
     */
    getDwr(dwrId: number): Observable<DwrForm> {
        let url_ = this.baseUrl + "/api/forms/dwr/{dwrId}";
        if (dwrId === undefined || dwrId === null)
            throw new Error("The parameter 'dwrId' must be defined.");
        url_ = url_.replace("{dwrId}", encodeURIComponent("" + dwrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DwrForm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DwrForm>;
        }));
    }

    protected processGetDwr(response: HttpResponseBase): Observable<DwrForm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DwrForm;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DwrForm>(null as any);
    }

    /**
     * @return OK
     */
    getDwrSummary(dwrId: number): Observable<DwrFormSummary> {
        let url_ = this.baseUrl + "/api/forms/dwrsummary/{dwrId}";
        if (dwrId === undefined || dwrId === null)
            throw new Error("The parameter 'dwrId' must be defined.");
        url_ = url_.replace("{dwrId}", encodeURIComponent("" + dwrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwrSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwrSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DwrFormSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DwrFormSummary>;
        }));
    }

    protected processGetDwrSummary(response: HttpResponseBase): Observable<DwrFormSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DwrFormSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DwrFormSummary>(null as any);
    }

    /**
     * @return OK
     */
    saveDwr(form: DwrForm): Observable<number> {
        let url_ = this.baseUrl + "/api/forms/dwr/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveDwr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveDwr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveDwr(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    getDwrCounts(args: DailyFormInfoRequest): Observable<DailyFormCounts[]> {
        let url_ = this.baseUrl + "/api/forms/dwr/counts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwrCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwrCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DailyFormCounts[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DailyFormCounts[]>;
        }));
    }

    protected processGetDwrCounts(response: HttpResponseBase): Observable<DailyFormCounts[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DailyFormCounts[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyFormCounts[]>(null as any);
    }

    /**
     * @return OK
     */
    getDwrOutOfJobRangeCounts(args: DailyFormInfoRequest): Observable<DailyOutOfJobRangeCount[]> {
        let url_ = this.baseUrl + "/api/forms/dwr/outOfRangeCounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwrOutOfJobRangeCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwrOutOfJobRangeCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DailyOutOfJobRangeCount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DailyOutOfJobRangeCount[]>;
        }));
    }

    protected processGetDwrOutOfJobRangeCounts(response: HttpResponseBase): Observable<DailyOutOfJobRangeCount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DailyOutOfJobRangeCount[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyOutOfJobRangeCount[]>(null as any);
    }

    /**
     * @return OK
     */
    getDailyDwrDetails(args: DailyFormInfoRequest): Observable<DailyFormDetailsOfDwrFormSummary> {
        let url_ = this.baseUrl + "/api/forms/dwr/dailydetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyDwrDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyDwrDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DailyFormDetailsOfDwrFormSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DailyFormDetailsOfDwrFormSummary>;
        }));
    }

    protected processGetDailyDwrDetails(response: HttpResponseBase): Observable<DailyFormDetailsOfDwrFormSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DailyFormDetailsOfDwrFormSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyFormDetailsOfDwrFormSummary>(null as any);
    }

    /**
     * @return OK
     */
    getDwrPhotoResponseData(formFieldResponseId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/forms/dwr/PhotoData/{formFieldResponseId}";
        if (formFieldResponseId === undefined || formFieldResponseId === null)
            throw new Error("The parameter 'formFieldResponseId' must be defined.");
        url_ = url_.replace("{formFieldResponseId}", encodeURIComponent("" + formFieldResponseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwrPhotoResponseData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwrPhotoResponseData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDwrPhotoResponseData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    getOdometerCaptureResponseData(formFieldResponseId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/forms/dwr/OdometerCaptureResponseData/{formFieldResponseId}";
        if (formFieldResponseId === undefined || formFieldResponseId === null)
            throw new Error("The parameter 'formFieldResponseId' must be defined.");
        url_ = url_.replace("{formFieldResponseId}", encodeURIComponent("" + formFieldResponseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOdometerCaptureResponseData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOdometerCaptureResponseData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetOdometerCaptureResponseData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    getOdometerCaptures(dwrId: number): Observable<OdometerCapture[]> {
        let url_ = this.baseUrl + "/api/forms/dwr/getOdometerCapture/{dwrId}";
        if (dwrId === undefined || dwrId === null)
            throw new Error("The parameter 'dwrId' must be defined.");
        url_ = url_.replace("{dwrId}", encodeURIComponent("" + dwrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOdometerCaptures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOdometerCaptures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OdometerCapture[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OdometerCapture[]>;
        }));
    }

    protected processGetOdometerCaptures(response: HttpResponseBase): Observable<OdometerCapture[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OdometerCapture[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OdometerCapture[]>(null as any);
    }

    /**
     * @return OK
     */
    getRwicSignatureData(dwrId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/forms/dwr/rwicsignature/{dwrId}";
        if (dwrId === undefined || dwrId === null)
            throw new Error("The parameter 'dwrId' must be defined.");
        url_ = url_.replace("{dwrId}", encodeURIComponent("" + dwrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRwicSignatureData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRwicSignatureData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRwicSignatureData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    getClientSignatureData(dwrId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/forms/dwr/clientsignature/{dwrId}";
        if (dwrId === undefined || dwrId === null)
            throw new Error("The parameter 'dwrId' must be defined.");
        url_ = url_.replace("{dwrId}", encodeURIComponent("" + dwrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientSignatureData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientSignatureData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetClientSignatureData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    getRailroadSignatureData(dwrId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/forms/dwr/railroadsignature/{dwrId}";
        if (dwrId === undefined || dwrId === null)
            throw new Error("The parameter 'dwrId' must be defined.");
        url_ = url_.replace("{dwrId}", encodeURIComponent("" + dwrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRailroadSignatureData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRailroadSignatureData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRailroadSignatureData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    canUpdateDwrStatus(dwrId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/forms/dwr/canUpdateDwrStatus/{dwrId}";
        if (dwrId === undefined || dwrId === null)
            throw new Error("The parameter 'dwrId' must be defined.");
        url_ = url_.replace("{dwrId}", encodeURIComponent("" + dwrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanUpdateDwrStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanUpdateDwrStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanUpdateDwrStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    areDwrsApproved(args: BulkDwrApprovalCheckRequest): Observable<boolean> {
        let url_ = this.baseUrl + "/api/forms/dwr/areDwrsApproved";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAreDwrsApproved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAreDwrsApproved(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAreDwrsApproved(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    areDwrsApprovedInBatch(batchId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/forms/dwr/areDwrsApprovedInBatch/{batchId}";
        if (batchId === undefined || batchId === null)
            throw new Error("The parameter 'batchId' must be defined.");
        url_ = url_.replace("{batchId}", encodeURIComponent("" + batchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAreDwrsApprovedInBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAreDwrsApprovedInBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAreDwrsApprovedInBatch(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getChangedDwrDates(fieldWorkerId: number, lastQueryTime: string): Observable<ChangedDwrDatesResponse> {
        let url_ = this.baseUrl + "/api/forms/dwr/changeddates/{fieldWorkerId}?";
        if (fieldWorkerId === undefined || fieldWorkerId === null)
            throw new Error("The parameter 'fieldWorkerId' must be defined.");
        url_ = url_.replace("{fieldWorkerId}", encodeURIComponent("" + fieldWorkerId));
        if (lastQueryTime === undefined || lastQueryTime === null)
            throw new Error("The parameter 'lastQueryTime' must be defined and cannot be null.");
        else
            url_ += "lastQueryTime=" + encodeURIComponent("" + lastQueryTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChangedDwrDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChangedDwrDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangedDwrDatesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangedDwrDatesResponse>;
        }));
    }

    protected processGetChangedDwrDates(response: HttpResponseBase): Observable<ChangedDwrDatesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangedDwrDatesResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangedDwrDatesResponse>(null as any);
    }

    /**
     * @return OK
     */
    getDataDrivenForm(railroadId: number, serviceTypeId: number, typeOfDay: number, nonBillableReason: number): Observable<DwrDataDrivenFormViewModel> {
        let url_ = this.baseUrl + "/api/forms/dwr/getdatadrivenform?";
        if (railroadId === undefined || railroadId === null)
            throw new Error("The parameter 'railroadId' must be defined and cannot be null.");
        else
            url_ += "railroadId=" + encodeURIComponent("" + railroadId) + "&";
        if (serviceTypeId === undefined || serviceTypeId === null)
            throw new Error("The parameter 'serviceTypeId' must be defined and cannot be null.");
        else
            url_ += "serviceTypeId=" + encodeURIComponent("" + serviceTypeId) + "&";
        if (typeOfDay === undefined || typeOfDay === null)
            throw new Error("The parameter 'typeOfDay' must be defined and cannot be null.");
        else
            url_ += "typeOfDay=" + encodeURIComponent("" + typeOfDay) + "&";
        if (nonBillableReason === undefined || nonBillableReason === null)
            throw new Error("The parameter 'nonBillableReason' must be defined and cannot be null.");
        else
            url_ += "nonBillableReason=" + encodeURIComponent("" + nonBillableReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataDrivenForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataDrivenForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DwrDataDrivenFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DwrDataDrivenFormViewModel>;
        }));
    }

    protected processGetDataDrivenForm(response: HttpResponseBase): Observable<DwrDataDrivenFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DwrDataDrivenFormViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DwrDataDrivenFormViewModel>(null as any);
    }

    /**
     * @return OK
     */
    getDwrFormsSchema(): Observable<DwrDataDrivenFormViewModel[]> {
        let url_ = this.baseUrl + "/api/forms/dwr/get-all-datadrivenforms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwrFormsSchema(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwrFormsSchema(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DwrDataDrivenFormViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DwrDataDrivenFormViewModel[]>;
        }));
    }

    protected processGetDwrFormsSchema(response: HttpResponseBase): Observable<DwrDataDrivenFormViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DwrDataDrivenFormViewModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DwrDataDrivenFormViewModel[]>(null as any);
    }

    /**
     * @return OK
     */
    saveDwrMobile(dwrPayload: DwrSubmissionViewModel): Observable<SaveFormMobileResponse> {
        let url_ = this.baseUrl + "/api/forms/dwr/datadrivenforms/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dwrPayload);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveDwrMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveDwrMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveFormMobileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveFormMobileResponse>;
        }));
    }

    protected processSaveDwrMobile(response: HttpResponseBase): Observable<SaveFormMobileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaveFormMobileResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveFormMobileResponse>(null as any);
    }

    /**
     * @return No Content
     */
    refreshDataDrivenForms(): Observable<void> {
        let url_ = this.baseUrl + "/api/forms/dwr/datadrivenforms/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshDataDrivenForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshDataDrivenForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefreshDataDrivenForms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getDwrsMobile(fieldWorkerId: number): Observable<DwrForm[]> {
        let url_ = this.baseUrl + "/api/forms/dwr/getDwrsMobile/{fieldWorkerId}";
        if (fieldWorkerId === undefined || fieldWorkerId === null)
            throw new Error("The parameter 'fieldWorkerId' must be defined.");
        url_ = url_.replace("{fieldWorkerId}", encodeURIComponent("" + fieldWorkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwrsMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwrsMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DwrForm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DwrForm[]>;
        }));
    }

    protected processGetDwrsMobile(response: HttpResponseBase): Observable<DwrForm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DwrForm[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DwrForm[]>(null as any);
    }

    /**
     * @return OK
     */
    getDwrDayClassifications(): Observable<DwrDayClassificationViewModel[]> {
        let url_ = this.baseUrl + "/api/forms/dwr/getDwrDayClassifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDwrDayClassifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDwrDayClassifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DwrDayClassificationViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DwrDayClassificationViewModel[]>;
        }));
    }

    protected processGetDwrDayClassifications(response: HttpResponseBase): Observable<DwrDayClassificationViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DwrDayClassificationViewModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DwrDayClassificationViewModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getNonbillableReasons(): Observable<NonbillableReasonViewModel[]> {
        let url_ = this.baseUrl + "/api/forms/dwr/getNonbillableReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNonbillableReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonbillableReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonbillableReasonViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonbillableReasonViewModel[]>;
        }));
    }

    protected processGetNonbillableReasons(response: HttpResponseBase): Observable<NonbillableReasonViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NonbillableReasonViewModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonbillableReasonViewModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getJobSetupForms(args: JobSetupFormListArgs): Observable<PagedResultsOfJobSetupFormSummary> {
        let url_ = this.baseUrl + "/api/forms/jobsetup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSetupForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSetupForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfJobSetupFormSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfJobSetupFormSummary>;
        }));
    }

    protected processGetJobSetupForms(response: HttpResponseBase): Observable<PagedResultsOfJobSetupFormSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfJobSetupFormSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfJobSetupFormSummary>(null as any);
    }

    /**
     * @return OK
     */
    getJobSetupForm(jobSetupFormId: number): Observable<JobSetupForm> {
        let url_ = this.baseUrl + "/api/forms/jobsetup/{jobSetupFormId}";
        if (jobSetupFormId === undefined || jobSetupFormId === null)
            throw new Error("The parameter 'jobSetupFormId' must be defined.");
        url_ = url_.replace("{jobSetupFormId}", encodeURIComponent("" + jobSetupFormId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSetupForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSetupForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSetupForm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSetupForm>;
        }));
    }

    protected processGetJobSetupForm(response: HttpResponseBase): Observable<JobSetupForm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobSetupForm;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobSetupForm>(null as any);
    }

    /**
     * @return OK
     */
    updateJobSetupForm(form: JobSetupForm): Observable<number> {
        let url_ = this.baseUrl + "/api/forms/jobsetup/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobSetupForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobSetupForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateJobSetupForm(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    getJobSetupCounts(args: DailyFormInfoRequest): Observable<DailyFormCounts[]> {
        let url_ = this.baseUrl + "/api/forms/jobsetup/counts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSetupCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSetupCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DailyFormCounts[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DailyFormCounts[]>;
        }));
    }

    protected processGetJobSetupCounts(response: HttpResponseBase): Observable<DailyFormCounts[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DailyFormCounts[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyFormCounts[]>(null as any);
    }

    /**
     * @return OK
     */
    getJobSetupOutOfJobRangeCounts(args: DailyFormInfoRequest): Observable<DailyOutOfJobRangeCount[]> {
        let url_ = this.baseUrl + "/api/forms/jobsetup/outOfRangeCounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSetupOutOfJobRangeCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSetupOutOfJobRangeCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DailyOutOfJobRangeCount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DailyOutOfJobRangeCount[]>;
        }));
    }

    protected processGetJobSetupOutOfJobRangeCounts(response: HttpResponseBase): Observable<DailyOutOfJobRangeCount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DailyOutOfJobRangeCount[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyOutOfJobRangeCount[]>(null as any);
    }

    /**
     * @return OK
     */
    getDailyJobSetupDetails(args: DailyFormInfoRequest): Observable<DailyFormDetailsOfJobSetupFormSummary> {
        let url_ = this.baseUrl + "/api/forms/jobsetup/dailydetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyJobSetupDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyJobSetupDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DailyFormDetailsOfJobSetupFormSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DailyFormDetailsOfJobSetupFormSummary>;
        }));
    }

    protected processGetDailyJobSetupDetails(response: HttpResponseBase): Observable<DailyFormDetailsOfJobSetupFormSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DailyFormDetailsOfJobSetupFormSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DailyFormDetailsOfJobSetupFormSummary>(null as any);
    }

    /**
     * @return OK
     */
    getJobSetupFormsSchema(): Observable<JobSetupDataDrivenFormViewModel[]> {
        let url_ = this.baseUrl + "/api/forms/jobsetups/get-all-datadrivenforms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSetupFormsSchema(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSetupFormsSchema(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSetupDataDrivenFormViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSetupDataDrivenFormViewModel[]>;
        }));
    }

    protected processGetJobSetupFormsSchema(response: HttpResponseBase): Observable<JobSetupDataDrivenFormViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobSetupDataDrivenFormViewModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobSetupDataDrivenFormViewModel[]>(null as any);
    }

    /**
     * @return OK
     */
    saveJobSetupMobile(jobSetupPayload: JobSetupSubmissionViewModel): Observable<SaveFormMobileResponse> {
        let url_ = this.baseUrl + "/api/forms/jobsetups/datadrivenforms/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobSetupPayload);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveJobSetupMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveJobSetupMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveFormMobileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveFormMobileResponse>;
        }));
    }

    protected processSaveJobSetupMobile(response: HttpResponseBase): Observable<SaveFormMobileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SaveFormMobileResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveFormMobileResponse>(null as any);
    }

    /**
     * @return OK
     */
    getJobSetupsMobile(fieldWorkerId: number): Observable<JobSetupForm[]> {
        let url_ = this.baseUrl + "/api/forms/jobsetups/getJobSetupsMobile/{fieldWorkerId}";
        if (fieldWorkerId === undefined || fieldWorkerId === null)
            throw new Error("The parameter 'fieldWorkerId' must be defined.");
        url_ = url_.replace("{fieldWorkerId}", encodeURIComponent("" + fieldWorkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSetupsMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSetupsMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSetupForm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSetupForm[]>;
        }));
    }

    protected processGetJobSetupsMobile(response: HttpResponseBase): Observable<JobSetupForm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobSetupForm[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobSetupForm[]>(null as any);
    }

    /**
     * @return OK
     */
    getJobSetupPhotoResponseData(formFieldResponseId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/forms/jobsetups/PhotoData/{formFieldResponseId}";
        if (formFieldResponseId === undefined || formFieldResponseId === null)
            throw new Error("The parameter 'formFieldResponseId' must be defined.");
        url_ = url_.replace("{formFieldResponseId}", encodeURIComponent("" + formFieldResponseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSetupPhotoResponseData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSetupPhotoResponseData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetJobSetupPhotoResponseData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    getJobSetupRwicSignatureData(jobSetupId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/forms/jobsetups/rwicsignature/{jobSetupId}";
        if (jobSetupId === undefined || jobSetupId === null)
            throw new Error("The parameter 'jobSetupId' must be defined.");
        url_ = url_.replace("{jobSetupId}", encodeURIComponent("" + jobSetupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobSetupRwicSignatureData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobSetupRwicSignatureData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetJobSetupRwicSignatureData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    getUtilityCoverSheets(args: UtilityCoverSheetListArgs): Observable<PagedResultsOfUtilityCoverSheetSummary> {
        let url_ = this.baseUrl + "/api/forms/utilityCoverSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityCoverSheets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityCoverSheets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfUtilityCoverSheetSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfUtilityCoverSheetSummary>;
        }));
    }

    protected processGetUtilityCoverSheets(response: HttpResponseBase): Observable<PagedResultsOfUtilityCoverSheetSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfUtilityCoverSheetSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfUtilityCoverSheetSummary>(null as any);
    }

    /**
     * @return OK
     */
    updateUtilityCoverSheet(form: UtilityCoverSheet): Observable<number> {
        let url_ = this.baseUrl + "/api/forms/utilityCoverSheet/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUtilityCoverSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUtilityCoverSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateUtilityCoverSheet(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    updateUtilityCoverSheetViewModel(viewModel: UtilityCoverSheetViewModel): Observable<number> {
        let url_ = this.baseUrl + "/api/forms/utilityCoverSheetViewModel/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUtilityCoverSheetViewModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUtilityCoverSheetViewModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateUtilityCoverSheetViewModel(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    getUtilityCoverSheet(utilityCoverSheetId: number): Observable<UtilityCoverSheet> {
        let url_ = this.baseUrl + "/api/forms/utilityCoverSheet/{utilityCoverSheetId}";
        if (utilityCoverSheetId === undefined || utilityCoverSheetId === null)
            throw new Error("The parameter 'utilityCoverSheetId' must be defined.");
        url_ = url_.replace("{utilityCoverSheetId}", encodeURIComponent("" + utilityCoverSheetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityCoverSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityCoverSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtilityCoverSheet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtilityCoverSheet>;
        }));
    }

    protected processGetUtilityCoverSheet(response: HttpResponseBase): Observable<UtilityCoverSheet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UtilityCoverSheet;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UtilityCoverSheet>(null as any);
    }

    /**
     * @return OK
     */
    getUtilityCoverSheetViewModel(utilityCoverSheetId: number): Observable<UtilityCoverSheetViewModel> {
        let url_ = this.baseUrl + "/api/forms/utilityCoverSheetViewModel/{utilityCoverSheetId}";
        if (utilityCoverSheetId === undefined || utilityCoverSheetId === null)
            throw new Error("The parameter 'utilityCoverSheetId' must be defined.");
        url_ = url_.replace("{utilityCoverSheetId}", encodeURIComponent("" + utilityCoverSheetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityCoverSheetViewModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityCoverSheetViewModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtilityCoverSheetViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtilityCoverSheetViewModel>;
        }));
    }

    protected processGetUtilityCoverSheetViewModel(response: HttpResponseBase): Observable<UtilityCoverSheetViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UtilityCoverSheetViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UtilityCoverSheetViewModel>(null as any);
    }

    /**
     * @return OK
     */
    getUtilityCoverSheetRwicSignatureData(utilityCoverSheetId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/forms/utilityCoverSheet/rwicSignature/{utilityCoverSheetId}";
        if (utilityCoverSheetId === undefined || utilityCoverSheetId === null)
            throw new Error("The parameter 'utilityCoverSheetId' must be defined.");
        url_ = url_.replace("{utilityCoverSheetId}", encodeURIComponent("" + utilityCoverSheetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityCoverSheetRwicSignatureData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityCoverSheetRwicSignatureData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUtilityCoverSheetRwicSignatureData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    getUtilityJobSetupForms(args: UtilityJobSetupFormListArgs): Observable<PagedResultsOfUtilityJobSetupFormSummary> {
        let url_ = this.baseUrl + "/api/forms/utilityJobSetup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityJobSetupForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityJobSetupForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfUtilityJobSetupFormSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfUtilityJobSetupFormSummary>;
        }));
    }

    protected processGetUtilityJobSetupForms(response: HttpResponseBase): Observable<PagedResultsOfUtilityJobSetupFormSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfUtilityJobSetupFormSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfUtilityJobSetupFormSummary>(null as any);
    }

    /**
     * @return OK
     */
    updateUtilityJobSetupForm(form: UtilityJobSetupForm): Observable<number> {
        let url_ = this.baseUrl + "/api/forms/utilityJobSetup/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUtilityJobSetupForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUtilityJobSetupForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateUtilityJobSetupForm(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    updateUtilityJobSetupFormViewModel(viewModel: UtilityJobSetupFormViewModel): Observable<number> {
        let url_ = this.baseUrl + "/api/forms/utilityJobSetupViewModel/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUtilityJobSetupFormViewModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUtilityJobSetupFormViewModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateUtilityJobSetupFormViewModel(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    getUtilityJobSetupForm(utilityJobSetupFormId: number): Observable<UtilityJobSetupForm> {
        let url_ = this.baseUrl + "/api/forms/utilityJobSetup/{utilityJobSetupFormId}";
        if (utilityJobSetupFormId === undefined || utilityJobSetupFormId === null)
            throw new Error("The parameter 'utilityJobSetupFormId' must be defined.");
        url_ = url_.replace("{utilityJobSetupFormId}", encodeURIComponent("" + utilityJobSetupFormId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityJobSetupForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityJobSetupForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtilityJobSetupForm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtilityJobSetupForm>;
        }));
    }

    protected processGetUtilityJobSetupForm(response: HttpResponseBase): Observable<UtilityJobSetupForm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UtilityJobSetupForm;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UtilityJobSetupForm>(null as any);
    }

    /**
     * @return OK
     */
    getUtilityJobSetupFormViewModel(utilityJobSetupFormId: number): Observable<UtilityJobSetupFormViewModel> {
        let url_ = this.baseUrl + "/api/forms/utilityJobSetupViewModel/{utilityJobSetupFormId}";
        if (utilityJobSetupFormId === undefined || utilityJobSetupFormId === null)
            throw new Error("The parameter 'utilityJobSetupFormId' must be defined.");
        url_ = url_.replace("{utilityJobSetupFormId}", encodeURIComponent("" + utilityJobSetupFormId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityJobSetupFormViewModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityJobSetupFormViewModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtilityJobSetupFormViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtilityJobSetupFormViewModel>;
        }));
    }

    protected processGetUtilityJobSetupFormViewModel(response: HttpResponseBase): Observable<UtilityJobSetupFormViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UtilityJobSetupFormViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UtilityJobSetupFormViewModel>(null as any);
    }

    /**
     * @return OK
     */
    getUtilityJobSetupFormRwicSignatureData(utilityJobSetupFormId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/forms/utilityJobSetup/rwicSignature/{utilityJobSetupFormId}";
        if (utilityJobSetupFormId === undefined || utilityJobSetupFormId === null)
            throw new Error("The parameter 'utilityJobSetupFormId' must be defined.");
        url_ = url_.replace("{utilityJobSetupFormId}", encodeURIComponent("" + utilityJobSetupFormId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityJobSetupFormRwicSignatureData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityJobSetupFormRwicSignatureData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUtilityJobSetupFormRwicSignatureData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    getSafetyAuditForms(args: SafetyAuditListArgs): Observable<PagedResultsOfSafetyAuditFormSummary> {
        let url_ = this.baseUrl + "/api/forms/audit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSafetyAuditForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSafetyAuditForms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfSafetyAuditFormSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfSafetyAuditFormSummary>;
        }));
    }

    protected processGetSafetyAuditForms(response: HttpResponseBase): Observable<PagedResultsOfSafetyAuditFormSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfSafetyAuditFormSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfSafetyAuditFormSummary>(null as any);
    }

    /**
     * @return OK
     */
    getSafetyAuditForm(auditFormId: number): Observable<SafetyAuditForm> {
        let url_ = this.baseUrl + "/api/forms/audit/{auditFormId}";
        if (auditFormId === undefined || auditFormId === null)
            throw new Error("The parameter 'auditFormId' must be defined.");
        url_ = url_.replace("{auditFormId}", encodeURIComponent("" + auditFormId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSafetyAuditForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSafetyAuditForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SafetyAuditForm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SafetyAuditForm>;
        }));
    }

    protected processGetSafetyAuditForm(response: HttpResponseBase): Observable<SafetyAuditForm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SafetyAuditForm;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SafetyAuditForm>(null as any);
    }

    /**
     * @return OK
     */
    updateSafetyAuditForm(form: SafetyAuditForm): Observable<number> {
        let url_ = this.baseUrl + "/api/forms/audit/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSafetyAuditForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSafetyAuditForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateSafetyAuditForm(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    getTemplates(args: FormTemplateListArgs): Observable<PagedResultsOfFormTemplateSummary> {
        let url_ = this.baseUrl + "/api/forms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfFormTemplateSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfFormTemplateSummary>;
        }));
    }

    protected processGetTemplates(response: HttpResponseBase): Observable<PagedResultsOfFormTemplateSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfFormTemplateSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfFormTemplateSummary>(null as any);
    }

    /**
     * @return OK
     */
    getTemplate(templateId: number): Observable<FormTemplate> {
        let url_ = this.baseUrl + "/api/forms/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormTemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormTemplate>;
        }));
    }

    protected processGetTemplate(response: HttpResponseBase): Observable<FormTemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormTemplate;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormTemplate>(null as any);
    }

    /**
     * @return OK
     */
    getFlashAudits(args: FlashAuditListArgs): Observable<PagedResultsOfFlashAuditSummary> {
        let url_ = this.baseUrl + "/api/forms/flashaudits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlashAudits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlashAudits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfFlashAuditSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfFlashAuditSummary>;
        }));
    }

    protected processGetFlashAudits(response: HttpResponseBase): Observable<PagedResultsOfFlashAuditSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfFlashAuditSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfFlashAuditSummary>(null as any);
    }

    /**
     * @return OK
     */
    saveFlashAudit(audit: FlashAudit): Observable<number> {
        let url_ = this.baseUrl + "/api/forms/flashaudit/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(audit);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFlashAudit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFlashAudit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveFlashAudit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    getFlashAudit(flashAuditId: number): Observable<FlashAudit> {
        let url_ = this.baseUrl + "/api/forms/flashaudit/{flashAuditId}";
        if (flashAuditId === undefined || flashAuditId === null)
            throw new Error("The parameter 'flashAuditId' must be defined.");
        url_ = url_.replace("{flashAuditId}", encodeURIComponent("" + flashAuditId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlashAudit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlashAudit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlashAudit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlashAudit>;
        }));
    }

    protected processGetFlashAudit(response: HttpResponseBase): Observable<FlashAudit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FlashAudit;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlashAudit>(null as any);
    }

    /**
     * @return No Content
     */
    expireFlashAudits(): Observable<void> {
        let url_ = this.baseUrl + "/api/forms/flashaudit/expire";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExpireFlashAudits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExpireFlashAudits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExpireFlashAudits(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getTravelTimeCandidates(dwrId: number): Observable<TravelTime[]> {
        let url_ = this.baseUrl + "/api/forms/dwr/travelTimeCandidates/{dwrId}";
        if (dwrId === undefined || dwrId === null)
            throw new Error("The parameter 'dwrId' must be defined.");
        url_ = url_.replace("{dwrId}", encodeURIComponent("" + dwrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelTimeCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelTimeCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TravelTime[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TravelTime[]>;
        }));
    }

    protected processGetTravelTimeCandidates(response: HttpResponseBase): Observable<TravelTime[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TravelTime[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelTime[]>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JobsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    getJobs(args: JobListArgs): Observable<PagedResultsOfJobSummary> {
        let url_ = this.baseUrl + "/api/jobs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfJobSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfJobSummary>;
        }));
    }

    protected processGetJobs(response: HttpResponseBase): Observable<PagedResultsOfJobSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfJobSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfJobSummary>(null as any);
    }

    /**
     * @return OK
     */
    getBillableJobs(args: BillableJobListArgs): Observable<PagedResultsOfBillableJobSummary> {
        let url_ = this.baseUrl + "/api/jobs/billable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillableJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillableJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfBillableJobSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfBillableJobSummary>;
        }));
    }

    protected processGetBillableJobs(response: HttpResponseBase): Observable<PagedResultsOfBillableJobSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfBillableJobSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfBillableJobSummary>(null as any);
    }

    /**
     * @return OK
     */
    getFullyInvoicedJobs(request: FullyInvoicedJobsRequest): Observable<InvoicedJobSummary[]> {
        let url_ = this.baseUrl + "/api/jobs/invoiced";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFullyInvoicedJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullyInvoicedJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoicedJobSummary[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoicedJobSummary[]>;
        }));
    }

    protected processGetFullyInvoicedJobs(response: HttpResponseBase): Observable<InvoicedJobSummary[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InvoicedJobSummary[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoicedJobSummary[]>(null as any);
    }

    /**
     * @return OK
     */
    getJob(jobId: number): Observable<Job> {
        let url_ = this.baseUrl + "/api/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Job>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Job>;
        }));
    }

    protected processGetJob(response: HttpResponseBase): Observable<Job> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Job;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Job>(null as any);
    }

    /**
     * @return OK
     */
    getJobsMobile(jobId: number[], fieldWorkerId: number): Observable<JobSummaryMobile[]> {
        let url_ = this.baseUrl + "/api/jobs/getJobsMobile?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            jobId && jobId.forEach(item => { url_ += "jobId=" + encodeURIComponent("" + item) + "&"; });
        if (fieldWorkerId === undefined || fieldWorkerId === null)
            throw new Error("The parameter 'fieldWorkerId' must be defined and cannot be null.");
        else
            url_ += "fieldWorkerId=" + encodeURIComponent("" + fieldWorkerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobsMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobsMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobSummaryMobile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobSummaryMobile[]>;
        }));
    }

    protected processGetJobsMobile(response: HttpResponseBase): Observable<JobSummaryMobile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobSummaryMobile[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobSummaryMobile[]>(null as any);
    }

    /**
     * @return OK
     */
    confirmPrevailingWages(jobId: number): Observable<ConfirmPrevailingWageResponse> {
        let url_ = this.baseUrl + "/api/jobs/ConfirmPrevailingWages/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPrevailingWages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPrevailingWages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfirmPrevailingWageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfirmPrevailingWageResponse>;
        }));
    }

    protected processConfirmPrevailingWages(response: HttpResponseBase): Observable<ConfirmPrevailingWageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConfirmPrevailingWageResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConfirmPrevailingWageResponse>(null as any);
    }

    /**
     * @return OK
     */
    getDocumentsForJob(jobId: number): Observable<Document[]> {
        let url_ = this.baseUrl + "/api/jobs/documents/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsForJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsForJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document[]>;
        }));
    }

    protected processGetDocumentsForJob(response: HttpResponseBase): Observable<Document[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Document[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Document[]>(null as any);
    }

    /**
     * @return OK
     */
    getAssignments(args: JobShiftListArgs): Observable<PagedResultsOfJobAssignment> {
        let url_ = this.baseUrl + "/api/jobs/assignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfJobAssignment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfJobAssignment>;
        }));
    }

    protected processGetAssignments(response: HttpResponseBase): Observable<PagedResultsOfJobAssignment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfJobAssignment;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfJobAssignment>(null as any);
    }

    /**
     * @return OK
     */
    getShifts(args: JobShiftListArgs): Observable<PagedResultsOfJobShift> {
        let url_ = this.baseUrl + "/api/jobs/shifts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfJobShift>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfJobShift>;
        }));
    }

    protected processGetShifts(response: HttpResponseBase): Observable<PagedResultsOfJobShift> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfJobShift;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfJobShift>(null as any);
    }

    /**
     * @return OK
     */
    getUnassignedShiftsForJob(jobId: number): Observable<JobShift[]> {
        let url_ = this.baseUrl + "/api/jobs/unassigned/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnassignedShiftsForJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnassignedShiftsForJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobShift[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobShift[]>;
        }));
    }

    protected processGetUnassignedShiftsForJob(response: HttpResponseBase): Observable<JobShift[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobShift[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobShift[]>(null as any);
    }

    /**
     * @return OK
     */
    saveJob(job: Job): Observable<number> {
        let url_ = this.baseUrl + "/api/jobs/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(job);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveJob(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    doesFlairDocsJobExist(flairDocsJobId: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/jobs/doesFlairDocsJobExist/{flairDocsJobId}";
        if (flairDocsJobId === undefined || flairDocsJobId === null)
            throw new Error("The parameter 'flairDocsJobId' must be defined.");
        url_ = url_.replace("{flairDocsJobId}", encodeURIComponent("" + flairDocsJobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoesFlairDocsJobExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoesFlairDocsJobExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDoesFlairDocsJobExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    cancelJobOrQuote(jobId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/jobs/cancel?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelJobOrQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelJobOrQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCancelJobOrQuote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    addDocumentToJob(request: NewDocumentRequest): Observable<Document> {
        let url_ = this.baseUrl + "/api/jobs/newDoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentToJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentToJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document>;
        }));
    }

    protected processAddDocumentToJob(response: HttpResponseBase): Observable<Document> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Document;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Document>(null as any);
    }

    /**
     * @return OK
     */
    addDocumentsToJob(request: NewDocumentRequest[]): Observable<Document[]> {
        let url_ = this.baseUrl + "/api/jobs/newDocs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentsToJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentsToJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document[]>;
        }));
    }

    protected processAddDocumentsToJob(response: HttpResponseBase): Observable<Document[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Document[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Document[]>(null as any);
    }

    /**
     * @return OK
     */
    approveFlairDocsRequest(jobRequest: FlairDocsJobRequest, railsCustomerId: number, apiRequestId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/jobs/approveFlairDocsRequest/{railsCustomerId}/{apiRequestId}";
        if (railsCustomerId === undefined || railsCustomerId === null)
            throw new Error("The parameter 'railsCustomerId' must be defined.");
        url_ = url_.replace("{railsCustomerId}", encodeURIComponent("" + railsCustomerId));
        if (apiRequestId === undefined || apiRequestId === null)
            throw new Error("The parameter 'apiRequestId' must be defined.");
        url_ = url_.replace("{apiRequestId}", encodeURIComponent("" + apiRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveFlairDocsRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveFlairDocsRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processApproveFlairDocsRequest(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    rejectFlairDocsRequest(apiRequestId: number): Observable<ApiRequest> {
        let url_ = this.baseUrl + "/api/jobs/rejectFlairDocsRequest/{apiRequestId}";
        if (apiRequestId === undefined || apiRequestId === null)
            throw new Error("The parameter 'apiRequestId' must be defined.");
        url_ = url_.replace("{apiRequestId}", encodeURIComponent("" + apiRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectFlairDocsRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectFlairDocsRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiRequest>;
        }));
    }

    protected processRejectFlairDocsRequest(response: HttpResponseBase): Observable<ApiRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiRequest;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiRequest>(null as any);
    }

    /**
     * @return OK
     */
    getQuoteLogs(args: QuoteListArgs): Observable<PagedResultsOfQuoteLogSummary> {
        let url_ = this.baseUrl + "/api/jobs/quotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuoteLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuoteLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfQuoteLogSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfQuoteLogSummary>;
        }));
    }

    protected processGetQuoteLogs(response: HttpResponseBase): Observable<PagedResultsOfQuoteLogSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfQuoteLogSummary;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfQuoteLogSummary>(null as any);
    }

    /**
     * @return OK
     */
    getQuoteLog(quoteLogId: number): Observable<QuoteLog> {
        let url_ = this.baseUrl + "/api/jobs/quote/{quoteLogId}";
        if (quoteLogId === undefined || quoteLogId === null)
            throw new Error("The parameter 'quoteLogId' must be defined.");
        url_ = url_.replace("{quoteLogId}", encodeURIComponent("" + quoteLogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuoteLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuoteLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteLog>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteLog>;
        }));
    }

    protected processGetQuoteLog(response: HttpResponseBase): Observable<QuoteLog> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuoteLog;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuoteLog>(null as any);
    }

    /**
     * @return OK
     */
    addQuoteLog(quote: QuoteLog): Observable<number> {
        let url_ = this.baseUrl + "/api/jobs/quote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quote);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQuoteLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQuoteLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddQuoteLog(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    getWeeklyShifts(request: WeeklyJobShiftsRequest): Observable<WeeklyJobShiftsResult[]> {
        let url_ = this.baseUrl + "/api/jobs/weekly/shifts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWeeklyShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWeeklyShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeeklyJobShiftsResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeeklyJobShiftsResult[]>;
        }));
    }

    protected processGetWeeklyShifts(response: HttpResponseBase): Observable<WeeklyJobShiftsResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WeeklyJobShiftsResult[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WeeklyJobShiftsResult[]>(null as any);
    }

    /**
     * @return OK
     */
    canDeleteJobShift(jobShiftId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/jobs/shift/candelete/{jobShiftId}";
        if (jobShiftId === undefined || jobShiftId === null)
            throw new Error("The parameter 'jobShiftId' must be defined.");
        url_ = url_.replace("{jobShiftId}", encodeURIComponent("" + jobShiftId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanDeleteJobShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanDeleteJobShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanDeleteJobShift(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return No Content
     */
    deleteJobShift(jobShiftId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/jobs/shift/{jobShiftId}";
        if (jobShiftId === undefined || jobShiftId === null)
            throw new Error("The parameter 'jobShiftId' must be defined.");
        url_ = url_.replace("{jobShiftId}", encodeURIComponent("" + jobShiftId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteJobShift(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return No Content
     */
    reportForDuty(jobShiftIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/jobs/shifts/reportForDuty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobShiftIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportForDuty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportForDuty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportForDuty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    reportForDutyAlerts(): Observable<number> {
        let url_ = this.baseUrl + "/api/jobs/shifts/reportForDutyAlerts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportForDutyAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportForDutyAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processReportForDutyAlerts(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    bulkAddShifts(request: BulkAddShiftsRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/jobs/shifts/bulkadd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkAddShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkAddShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processBulkAddShifts(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    addShift(shift: JobShift): Observable<number> {
        let url_ = this.baseUrl + "/api/jobs/shifts/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shift);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddShift(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    countShiftsWithRwics(request: BulkDeleteShiftsRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/jobs/shifts/countscheduled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountShiftsWithRwics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountShiftsWithRwics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCountShiftsWithRwics(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return No Content
     */
    bulkDeleteFutureShifts(request: BulkDeleteShiftsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/jobs/shifts/bulkdelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkDeleteFutureShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkDeleteFutureShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkDeleteFutureShifts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    bulkAssignShifts(request: BulkAssignShiftsRequest): Observable<BulkAssignShiftsResponse[]> {
        let url_ = this.baseUrl + "/api/jobs/shifts/bulkassign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkAssignShifts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkAssignShifts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkAssignShiftsResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkAssignShiftsResponse[]>;
        }));
    }

    protected processBulkAssignShifts(response: HttpResponseBase): Observable<BulkAssignShiftsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkAssignShiftsResponse[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BulkAssignShiftsResponse[]>(null as any);
    }

    /**
     * @return OK
     */
    getTermsOfService(jobId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/jobs/terms/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermsOfService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermsOfService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTermsOfService(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return OK
     */
    getJobsPickList(searchText: string): Observable<JobLink[]> {
        let url_ = this.baseUrl + "/api/jobs/jobLinks/{searchText}";
        if (searchText === undefined || searchText === null)
            throw new Error("The parameter 'searchText' must be defined.");
        url_ = url_.replace("{searchText}", encodeURIComponent("" + searchText));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobsPickList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobsPickList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLink[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLink[]>;
        }));
    }

    protected processGetJobsPickList(response: HttpResponseBase): Observable<JobLink[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobLink[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobLink[]>(null as any);
    }

    /**
     * @return OK
     */
    getJobLink(jobId: number): Observable<JobLink> {
        let url_ = this.baseUrl + "/api/jobs/jobLink/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobLink>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobLink>;
        }));
    }

    protected processGetJobLink(response: HttpResponseBase): Observable<JobLink> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobLink;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobLink>(null as any);
    }

    /**
     * @return OK
     */
    getLocationsPickList(searchText: string): Observable<AddressLink[]> {
        let url_ = this.baseUrl + "/api/jobs/addressSearch?";
        if (searchText === undefined || searchText === null)
            throw new Error("The parameter 'searchText' must be defined and cannot be null.");
        else
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationsPickList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationsPickList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressLink[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressLink[]>;
        }));
    }

    protected processGetLocationsPickList(response: HttpResponseBase): Observable<AddressLink[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressLink[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressLink[]>(null as any);
    }

    /**
     * @return OK
     */
    getCostCenters(jobId: number): Observable<JobCostCenter[]> {
        let url_ = this.baseUrl + "/api/jobs/costcenters/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostCenters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostCenters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobCostCenter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobCostCenter[]>;
        }));
    }

    protected processGetCostCenters(response: HttpResponseBase): Observable<JobCostCenter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCostCenter[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobCostCenter[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllCostCenters(): Observable<JobCostCenter[]> {
        let url_ = this.baseUrl + "/api/jobs/costcenters/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCostCenters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCostCenters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobCostCenter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobCostCenter[]>;
        }));
    }

    protected processGetAllCostCenters(response: HttpResponseBase): Observable<JobCostCenter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobCostCenter[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobCostCenter[]>(null as any);
    }

    /**
     * @return OK
     */
    addJobCostCenter(item: JobCostCenter): Observable<number> {
        let url_ = this.baseUrl + "/api/jobs/costcenter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddJobCostCenter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddJobCostCenter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddJobCostCenter(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return No Content
     */
    deleteJobCostCenter(costCenterId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/jobs/costcenter/delete/{costCenterId}";
        if (costCenterId === undefined || costCenterId === null)
            throw new Error("The parameter 'costCenterId' must be defined.");
        url_ = url_.replace("{costCenterId}", encodeURIComponent("" + costCenterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobCostCenter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobCostCenter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteJobCostCenter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getAutocompleteValuesForOptionalFields(railroadId: number): Observable<JobOptionalFieldsAutocompleteValues> {
        let url_ = this.baseUrl + "/api/jobs/autocompleteValuesForOptionalFields?";
        if (railroadId === undefined || railroadId === null)
            throw new Error("The parameter 'railroadId' must be defined and cannot be null.");
        else
            url_ += "railroadId=" + encodeURIComponent("" + railroadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutocompleteValuesForOptionalFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutocompleteValuesForOptionalFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobOptionalFieldsAutocompleteValues>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobOptionalFieldsAutocompleteValues>;
        }));
    }

    protected processGetAutocompleteValuesForOptionalFields(response: HttpResponseBase): Observable<JobOptionalFieldsAutocompleteValues> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobOptionalFieldsAutocompleteValues;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobOptionalFieldsAutocompleteValues>(null as any);
    }

    /**
     * @return OK
     */
    getJobLogs(jobId: number): Observable<PagedResultsOfAuditTrail> {
        let url_ = this.baseUrl + "/api/jobs/history/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfAuditTrail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfAuditTrail>;
        }));
    }

    protected processGetJobLogs(response: HttpResponseBase): Observable<PagedResultsOfAuditTrail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfAuditTrail;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfAuditTrail>(null as any);
    }

    /**
     * @return No Content
     */
    alertAmountThreshold(): Observable<void> {
        let url_ = this.baseUrl + "/api/jobs/alertAmountThreshold";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAlertAmountThreshold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAlertAmountThreshold(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAlertAmountThreshold(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LookupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    getFieldWorkerTypes(): Observable<FieldWorkerType[]> {
        let url_ = this.baseUrl + "/api/lookup/fieldworkertypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldWorkerTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldWorkerTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldWorkerType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldWorkerType[]>;
        }));
    }

    protected processGetFieldWorkerTypes(response: HttpResponseBase): Observable<FieldWorkerType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldWorkerType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldWorkerType[]>(null as any);
    }

    /**
     * @return OK
     */
    getFieldWorkerType(fieldworkerTypeId: number): Observable<FieldWorkerType> {
        let url_ = this.baseUrl + "/api/lookup/fieldworkertype/{fieldworkerTypeId}";
        if (fieldworkerTypeId === undefined || fieldworkerTypeId === null)
            throw new Error("The parameter 'fieldworkerTypeId' must be defined.");
        url_ = url_.replace("{fieldworkerTypeId}", encodeURIComponent("" + fieldworkerTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldWorkerType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldWorkerType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldWorkerType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldWorkerType>;
        }));
    }

    protected processGetFieldWorkerType(response: HttpResponseBase): Observable<FieldWorkerType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldWorkerType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldWorkerType>(null as any);
    }

    /**
     * @return OK
     */
    getEmployeeStatuses(): Observable<EmployeeStatus[]> {
        let url_ = this.baseUrl + "/api/lookup/employeestatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeStatus[]>;
        }));
    }

    protected processGetEmployeeStatuses(response: HttpResponseBase): Observable<EmployeeStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeStatus[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeStatus[]>(null as any);
    }

    /**
     * @return OK
     */
    getEmployeeStatus(employeeStatusId: number): Observable<EmployeeStatus> {
        let url_ = this.baseUrl + "/api/lookup/employeestatus/{employeeStatusId}";
        if (employeeStatusId === undefined || employeeStatusId === null)
            throw new Error("The parameter 'employeeStatusId' must be defined.");
        url_ = url_.replace("{employeeStatusId}", encodeURIComponent("" + employeeStatusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeStatus>;
        }));
    }

    protected processGetEmployeeStatus(response: HttpResponseBase): Observable<EmployeeStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeStatus>(null as any);
    }

    /**
     * @return OK
     */
    getFormTypes(): Observable<FormType[]> {
        let url_ = this.baseUrl + "/api/lookup/formtypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormType[]>;
        }));
    }

    protected processGetFormTypes(response: HttpResponseBase): Observable<FormType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormType[]>(null as any);
    }

    /**
     * @return OK
     */
    getFormType(formTypeId: number): Observable<FormType> {
        let url_ = this.baseUrl + "/api/lookup/formtype/{formTypeId}";
        if (formTypeId === undefined || formTypeId === null)
            throw new Error("The parameter 'formTypeId' must be defined.");
        url_ = url_.replace("{formTypeId}", encodeURIComponent("" + formTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormType>;
        }));
    }

    protected processGetFormType(response: HttpResponseBase): Observable<FormType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormType;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormType>(null as any);
    }

    /**
     * @return OK
     */
    getFilledOutFormStatuses(): Observable<FilledOutFormStatus[]> {
        let url_ = this.baseUrl + "/api/lookup/formstatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilledOutFormStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilledOutFormStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilledOutFormStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilledOutFormStatus[]>;
        }));
    }

    protected processGetFilledOutFormStatuses(response: HttpResponseBase): Observable<FilledOutFormStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FilledOutFormStatus[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FilledOutFormStatus[]>(null as any);
    }

    /**
     * @return OK
     */
    getServiceTypes(): Observable<ServiceType[]> {
        let url_ = this.baseUrl + "/api/lookup/servicetypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceType[]>;
        }));
    }

    protected processGetServiceTypes(response: HttpResponseBase): Observable<ServiceType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceType[]>(null as any);
    }

    /**
     * @return OK
     */
    getFilledOutFormStatus(formStatusId: number): Observable<FilledOutFormStatus> {
        let url_ = this.baseUrl + "/api/lookup/formstatus/{formStatusId}";
        if (formStatusId === undefined || formStatusId === null)
            throw new Error("The parameter 'formStatusId' must be defined.");
        url_ = url_.replace("{formStatusId}", encodeURIComponent("" + formStatusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilledOutFormStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilledOutFormStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilledOutFormStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilledOutFormStatus>;
        }));
    }

    protected processGetFilledOutFormStatus(response: HttpResponseBase): Observable<FilledOutFormStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FilledOutFormStatus;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FilledOutFormStatus>(null as any);
    }

    /**
     * @return OK
     */
    getAdministratorDetails(): Observable<AdministratorDetails> {
        let url_ = this.baseUrl + "/api/lookup/administratordetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdministratorDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdministratorDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministratorDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministratorDetails>;
        }));
    }

    protected processGetAdministratorDetails(response: HttpResponseBase): Observable<AdministratorDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdministratorDetails;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdministratorDetails>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    getUnread(fieldWorkerId: number): Observable<NotificationLog[]> {
        let url_ = this.baseUrl + "/api/notification/unread/{fieldWorkerId}";
        if (fieldWorkerId === undefined || fieldWorkerId === null)
            throw new Error("The parameter 'fieldWorkerId' must be defined.");
        url_ = url_.replace("{fieldWorkerId}", encodeURIComponent("" + fieldWorkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationLog[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationLog[]>;
        }));
    }

    protected processGetUnread(response: HttpResponseBase): Observable<NotificationLog[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationLog[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationLog[]>(null as any);
    }

    /**
     * @return OK
     */
    getUnread2(portalUserId: string): Observable<NotificationLog[]> {
        let url_ = this.baseUrl + "/api/notification/portal/{portalUserId}";
        if (portalUserId === undefined || portalUserId === null)
            throw new Error("The parameter 'portalUserId' must be defined.");
        url_ = url_.replace("{portalUserId}", encodeURIComponent("" + portalUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnread2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnread2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationLog[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationLog[]>;
        }));
    }

    protected processGetUnread2(response: HttpResponseBase): Observable<NotificationLog[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationLog[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationLog[]>(null as any);
    }

    /**
     * @return No Content
     */
    markNotificationAsRead(notificationLogId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/notification/markread/{notificationLogId}";
        if (notificationLogId === undefined || notificationLogId === null)
            throw new Error("The parameter 'notificationLogId' must be defined.");
        url_ = url_.replace("{notificationLogId}", encodeURIComponent("" + notificationLogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return No Content
     */
    markNotificationAsUnread(notificationLogId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/notification/markunread/{notificationLogId}";
        if (notificationLogId === undefined || notificationLogId === null)
            throw new Error("The parameter 'notificationLogId' must be defined.");
        url_ = url_.replace("{notificationLogId}", encodeURIComponent("" + notificationLogId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkNotificationAsUnread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkNotificationAsUnread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkNotificationAsUnread(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getNotificationCategories(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/notification/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetNotificationCategories(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @return No Content
     */
    sendAdHocNotificationToRwic(request: AdHocNotificationRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/notification/adhoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAdHocNotificationToRwic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAdHocNotificationToRwic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendAdHocNotificationToRwic(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PersonnelClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    getFieldWorkers(args: FieldWorkerListArgs): Observable<PagedResultsOfFieldWorker> {
        let url_ = this.baseUrl + "/api/personnel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldWorkers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldWorkers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfFieldWorker>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfFieldWorker>;
        }));
    }

    protected processGetFieldWorkers(response: HttpResponseBase): Observable<PagedResultsOfFieldWorker> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfFieldWorker;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfFieldWorker>(null as any);
    }

    /**
     * @return OK
     */
    getFieldManagersPickList(): Observable<FieldWorkerLink[]> {
        let url_ = this.baseUrl + "/api/personnel/fieldmanager/picklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldManagersPickList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldManagersPickList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldWorkerLink[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldWorkerLink[]>;
        }));
    }

    protected processGetFieldManagersPickList(response: HttpResponseBase): Observable<FieldWorkerLink[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldWorkerLink[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldWorkerLink[]>(null as any);
    }

    /**
     * @return OK
     */
    getFieldWorker(fieldworkerId: number): Observable<FieldWorker> {
        let url_ = this.baseUrl + "/api/personnel/fieldworker/{fieldworkerId}";
        if (fieldworkerId === undefined || fieldworkerId === null)
            throw new Error("The parameter 'fieldworkerId' must be defined.");
        url_ = url_.replace("{fieldworkerId}", encodeURIComponent("" + fieldworkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldWorker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldWorker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldWorker>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldWorker>;
        }));
    }

    protected processGetFieldWorker(response: HttpResponseBase): Observable<FieldWorker> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldWorker;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldWorker>(null as any);
    }

    /**
     * @return OK
     */
    getFieldWorkerByActiveDirectoryId(activeDirectoryUserId: string): Observable<FieldWorkerLink> {
        let url_ = this.baseUrl + "/api/personnel/fieldworker/ad/{activeDirectoryUserId}";
        if (activeDirectoryUserId === undefined || activeDirectoryUserId === null)
            throw new Error("The parameter 'activeDirectoryUserId' must be defined.");
        url_ = url_.replace("{activeDirectoryUserId}", encodeURIComponent("" + activeDirectoryUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldWorkerByActiveDirectoryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldWorkerByActiveDirectoryId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldWorkerLink>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldWorkerLink>;
        }));
    }

    protected processGetFieldWorkerByActiveDirectoryId(response: HttpResponseBase): Observable<FieldWorkerLink> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldWorkerLink;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldWorkerLink>(null as any);
    }

    /**
     * @return OK
     */
    saveFieldWorker(fieldworker: FieldWorker): Observable<number> {
        let url_ = this.baseUrl + "/api/personnel/fieldworker/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fieldworker);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFieldWorker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFieldWorker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveFieldWorker(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    getFieldWorkerHistory(fieldworkerId: number): Observable<PagedResultsOfAuditTrail> {
        let url_ = this.baseUrl + "/api/personnel/fieldworker/history/{fieldworkerId}";
        if (fieldworkerId === undefined || fieldworkerId === null)
            throw new Error("The parameter 'fieldworkerId' must be defined.");
        url_ = url_.replace("{fieldworkerId}", encodeURIComponent("" + fieldworkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldWorkerHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldWorkerHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfAuditTrail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfAuditTrail>;
        }));
    }

    protected processGetFieldWorkerHistory(response: HttpResponseBase): Observable<PagedResultsOfAuditTrail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfAuditTrail;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfAuditTrail>(null as any);
    }

    /**
     * @return OK
     */
    getTeams(args: FieldTeamListArgs): Observable<PagedResultsOfFieldTeam> {
        let url_ = this.baseUrl + "/api/personnel/teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfFieldTeam>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfFieldTeam>;
        }));
    }

    protected processGetTeams(response: HttpResponseBase): Observable<PagedResultsOfFieldTeam> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfFieldTeam;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfFieldTeam>(null as any);
    }

    /**
     * @return OK
     */
    getTeam(teamId: number): Observable<FieldTeam> {
        let url_ = this.baseUrl + "/api/personnel/team/{teamId}";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldTeam>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldTeam>;
        }));
    }

    protected processGetTeam(response: HttpResponseBase): Observable<FieldTeam> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldTeam;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldTeam>(null as any);
    }

    /**
     * @return OK
     */
    getTeamLink(teamId: number): Observable<FieldTeamLink> {
        let url_ = this.baseUrl + "/api/personnel/teamLink/{teamId}";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTeamLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTeamLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldTeamLink>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldTeamLink>;
        }));
    }

    protected processGetTeamLink(response: HttpResponseBase): Observable<FieldTeamLink> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldTeamLink;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldTeamLink>(null as any);
    }

    /**
     * @return OK
     */
    saveTeam(team: FieldTeam): Observable<number> {
        let url_ = this.baseUrl + "/api/personnel/team/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(team);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveTeam(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    getUserLinkOptions(): Observable<UserLink[]> {
        let url_ = this.baseUrl + "/api/personnel/userLinkOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLinkOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLinkOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLink[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLink[]>;
        }));
    }

    protected processGetUserLinkOptions(response: HttpResponseBase): Observable<UserLink[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserLink[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLink[]>(null as any);
    }

    /**
     * @return OK
     */
    getCertificationTypes(): Observable<CertificationType[]> {
        let url_ = this.baseUrl + "/api/personnel/certificationtypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificationType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificationType[]>;
        }));
    }

    protected processGetCertificationTypes(response: HttpResponseBase): Observable<CertificationType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificationType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificationType[]>(null as any);
    }

    /**
     * @return OK
     */
    getCertificationTypes2(searchText: string): Observable<CertificationType[]> {
        let url_ = this.baseUrl + "/api/personnel/certificationtypes/{searchText}";
        if (searchText === undefined || searchText === null)
            throw new Error("The parameter 'searchText' must be defined.");
        url_ = url_.replace("{searchText}", encodeURIComponent("" + searchText));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificationTypes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificationTypes2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificationType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificationType[]>;
        }));
    }

    protected processGetCertificationTypes2(response: HttpResponseBase): Observable<CertificationType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificationType[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificationType[]>(null as any);
    }

    /**
     * @return OK
     */
    canUpdateFieldWorker(worker: FieldWorker): Observable<boolean> {
        let url_ = this.baseUrl + "/api/personnel/fieldworker/canupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(worker);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanUpdateFieldWorker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanUpdateFieldWorker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanUpdateFieldWorker(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    isEmployeeCodeUnique(worker: FieldWorker): Observable<boolean> {
        let url_ = this.baseUrl + "/api/personnel/fieldworker/IsEmployeeCodeUnique";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(worker);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEmployeeCodeUnique(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEmployeeCodeUnique(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEmployeeCodeUnique(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    isPaycomIdUnique(worker: FieldWorker): Observable<boolean> {
        let url_ = this.baseUrl + "/api/personnel/fieldworker/IsPaycomIdUnique";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(worker);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsPaycomIdUnique(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsPaycomIdUnique(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsPaycomIdUnique(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReportsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    invoiceDataEntryReport(invoiceCandidateId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/InvoiceDataEntryReport/{invoiceCandidateId}";
        if (invoiceCandidateId === undefined || invoiceCandidateId === null)
            throw new Error("The parameter 'invoiceCandidateId' must be defined.");
        url_ = url_.replace("{invoiceCandidateId}", encodeURIComponent("" + invoiceCandidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoiceDataEntryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoiceDataEntryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processInvoiceDataEntryReport(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    invoiceArtifacts(invoiceCandidateId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/InvoiceArtifacts/{invoiceCandidateId}";
        if (invoiceCandidateId === undefined || invoiceCandidateId === null)
            throw new Error("The parameter 'invoiceCandidateId' must be defined.");
        url_ = url_.replace("{invoiceCandidateId}", encodeURIComponent("" + invoiceCandidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoiceArtifacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoiceArtifacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processInvoiceArtifacts(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    getAndCacheInvoiceArtifacts(invoiceCandidateId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/InvoiceArtifacts/{invoiceCandidateId}";
        if (invoiceCandidateId === undefined || invoiceCandidateId === null)
            throw new Error("The parameter 'invoiceCandidateId' must be defined.");
        url_ = url_.replace("{invoiceCandidateId}", encodeURIComponent("" + invoiceCandidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAndCacheInvoiceArtifacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAndCacheInvoiceArtifacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetAndCacheInvoiceArtifacts(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    checkIfInvoiceArtifactsAreReady(invoiceCandidateId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/reports/InvoiceArtifactsStatus/{invoiceCandidateId}";
        if (invoiceCandidateId === undefined || invoiceCandidateId === null)
            throw new Error("The parameter 'invoiceCandidateId' must be defined.");
        url_ = url_.replace("{invoiceCandidateId}", encodeURIComponent("" + invoiceCandidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfInvoiceArtifactsAreReady(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfInvoiceArtifactsAreReady(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfInvoiceArtifactsAreReady(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    bundleDwrsForInvoice(invoiceCandidateId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/DwrsForInvoice/{invoiceCandidateId}";
        if (invoiceCandidateId === undefined || invoiceCandidateId === null)
            throw new Error("The parameter 'invoiceCandidateId' must be defined.");
        url_ = url_.replace("{invoiceCandidateId}", encodeURIComponent("" + invoiceCandidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBundleDwrsForInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBundleDwrsForInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processBundleDwrsForInvoice(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    dwrReport(dwrId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/DwrReport/{dwrId}";
        if (dwrId === undefined || dwrId === null)
            throw new Error("The parameter 'dwrId' must be defined.");
        url_ = url_.replace("{dwrId}", encodeURIComponent("" + dwrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDwrReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDwrReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDwrReport(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    dprReport(dwrId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/DprReport/{dwrId}";
        if (dwrId === undefined || dwrId === null)
            throw new Error("The parameter 'dwrId' must be defined.");
        url_ = url_.replace("{dwrId}", encodeURIComponent("" + dwrId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDprReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDprReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDprReport(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    jobSetupReport(jsId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/JobSetupReport/{jsId}";
        if (jsId === undefined || jsId === null)
            throw new Error("The parameter 'jsId' must be defined.");
        url_ = url_.replace("{jsId}", encodeURIComponent("" + jsId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJobSetupReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJobSetupReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processJobSetupReport(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    getUtilityJobSetupReport(utilityJobSetupId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/UtilityJobSetupReport/{utilityJobSetupId}";
        if (utilityJobSetupId === undefined || utilityJobSetupId === null)
            throw new Error("The parameter 'utilityJobSetupId' must be defined.");
        url_ = url_.replace("{utilityJobSetupId}", encodeURIComponent("" + utilityJobSetupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityJobSetupReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityJobSetupReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetUtilityJobSetupReport(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    getUtilityCoverSheetReport(utilityCoverSheetId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/UtilityCoverSheetReport/{utilityCoverSheetId}";
        if (utilityCoverSheetId === undefined || utilityCoverSheetId === null)
            throw new Error("The parameter 'utilityCoverSheetId' must be defined.");
        url_ = url_.replace("{utilityCoverSheetId}", encodeURIComponent("" + utilityCoverSheetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilityCoverSheetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilityCoverSheetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetUtilityCoverSheetReport(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    dwrReports(args: DwrListArgs): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/DwrReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDwrReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDwrReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDwrReports(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    billableJobsListCsv(args: BillableJobListArgs): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/BillableJobsListCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBillableJobsListCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBillableJobsListCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processBillableJobsListCsv(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    payrollMonthlyReportCsv(jobId: number, startDate: string): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/PayrollMonthlyReportCsv/{jobId}/{startDate}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent("" + startDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPayrollMonthlyReportCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayrollMonthlyReportCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processPayrollMonthlyReportCsv(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    hasPrevailingWageItem(jobId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/reports/PrevailingWagePayrollValidation/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasPrevailingWageItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasPrevailingWageItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasPrevailingWageItem(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return OK
     */
    prevailingWagePayrollReport(jobId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/PrevailingWagePayrollReport/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrevailingWagePayrollReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrevailingWagePayrollReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processPrevailingWagePayrollReport(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    excludedPaycheckCsv(payrollBatchId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/excludedPaycheckCsv/{payrollBatchId}";
        if (payrollBatchId === undefined || payrollBatchId === null)
            throw new Error("The parameter 'payrollBatchId' must be defined.");
        url_ = url_.replace("{payrollBatchId}", encodeURIComponent("" + payrollBatchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcludedPaycheckCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcludedPaycheckCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processExcludedPaycheckCsv(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    invoiceSummaryCsv(request: InvoiceSummaryArgs): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/InvoiceSummaryCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoiceSummaryCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoiceSummaryCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processInvoiceSummaryCsv(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    quoteReport(quoteId: number, addToDocuments: boolean): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/QuoteReport?";
        if (quoteId === undefined || quoteId === null)
            throw new Error("The parameter 'quoteId' must be defined and cannot be null.");
        else
            url_ += "quoteId=" + encodeURIComponent("" + quoteId) + "&";
        if (addToDocuments === undefined || addToDocuments === null)
            throw new Error("The parameter 'addToDocuments' must be defined and cannot be null.");
        else
            url_ += "addToDocuments=" + encodeURIComponent("" + addToDocuments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuoteReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuoteReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processQuoteReport(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return No Content
     */
    runAndMailDailyDwrSubmissions(railroadId: number, toEmailAddresses: string): Observable<void> {
        let url_ = this.baseUrl + "/api/reports/DailyDwrSubmissionsReport/{railroadId}/{toEmailAddresses}";
        if (railroadId === undefined || railroadId === null)
            throw new Error("The parameter 'railroadId' must be defined.");
        url_ = url_.replace("{railroadId}", encodeURIComponent("" + railroadId));
        if (toEmailAddresses === undefined || toEmailAddresses === null)
            throw new Error("The parameter 'toEmailAddresses' must be defined.");
        url_ = url_.replace("{toEmailAddresses}", encodeURIComponent("" + toEmailAddresses));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunAndMailDailyDwrSubmissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunAndMailDailyDwrSubmissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunAndMailDailyDwrSubmissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    runAndMailDailySchedule(date: string, toEmailAddresses: string): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/DailyScheduleReport/{date}/{toEmailAddresses}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (toEmailAddresses === undefined || toEmailAddresses === null)
            throw new Error("The parameter 'toEmailAddresses' must be defined.");
        url_ = url_.replace("{toEmailAddresses}", encodeURIComponent("" + toEmailAddresses));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunAndMailDailySchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunAndMailDailySchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processRunAndMailDailySchedule(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return No Content
     */
    runAndMailWeeklyUnapprovedDwrs(sendToEmail: string): Observable<void> {
        let url_ = this.baseUrl + "/api/reports/WeeklyUnapprovedDwrs/{sendToEmail}";
        if (sendToEmail === undefined || sendToEmail === null)
            throw new Error("The parameter 'sendToEmail' must be defined.");
        url_ = url_.replace("{sendToEmail}", encodeURIComponent("" + sendToEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunAndMailWeeklyUnapprovedDwrs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunAndMailWeeklyUnapprovedDwrs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunAndMailWeeklyUnapprovedDwrs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    runAndMailNsWeeklySummary(sendToEmail: string): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/NsWeeklySummaryReport/{sendToEmail}";
        if (sendToEmail === undefined || sendToEmail === null)
            throw new Error("The parameter 'sendToEmail' must be defined.");
        url_ = url_.replace("{sendToEmail}", encodeURIComponent("" + sendToEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunAndMailNsWeeklySummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunAndMailNsWeeklySummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processRunAndMailNsWeeklySummary(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    getWcrReportA(invoiceCandidateId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/WcrReportA/{invoiceCandidateId}";
        if (invoiceCandidateId === undefined || invoiceCandidateId === null)
            throw new Error("The parameter 'invoiceCandidateId' must be defined.");
        url_ = url_.replace("{invoiceCandidateId}", encodeURIComponent("" + invoiceCandidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWcrReportA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWcrReportA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetWcrReportA(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    getWcrReportB(invoiceCandidateId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/WcrReportB/{invoiceCandidateId}";
        if (invoiceCandidateId === undefined || invoiceCandidateId === null)
            throw new Error("The parameter 'invoiceCandidateId' must be defined.");
        url_ = url_.replace("{invoiceCandidateId}", encodeURIComponent("" + invoiceCandidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWcrReportB(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWcrReportB(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetWcrReportB(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    getWcrReports(invoiceCandidateId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/WcrReports/{invoiceCandidateId}";
        if (invoiceCandidateId === undefined || invoiceCandidateId === null)
            throw new Error("The parameter 'invoiceCandidateId' must be defined.");
        url_ = url_.replace("{invoiceCandidateId}", encodeURIComponent("" + invoiceCandidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWcrReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWcrReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetWcrReports(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    invoiceBundleReport(request: InvoiceBundleReportRequest): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/InvoiceBundleReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoiceBundleReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoiceBundleReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processInvoiceBundleReport(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    kcsReport(): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/KcsReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKcsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKcsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processKcsReport(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    runAndMailKcsReport(toEmailAddresses: string): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/RunAndMailKcsReport/{toEmailAddresses}";
        if (toEmailAddresses === undefined || toEmailAddresses === null)
            throw new Error("The parameter 'toEmailAddresses' must be defined.");
        url_ = url_.replace("{toEmailAddresses}", encodeURIComponent("" + toEmailAddresses));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunAndMailKcsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunAndMailKcsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processRunAndMailKcsReport(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    kcsReportHeader(): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/KcsReportHeader";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKcsReportHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKcsReportHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processKcsReportHeader(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    utilityReportFooter(): Observable<any> {
        let url_ = this.baseUrl + "/api/reports/UtilityReportFooter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUtilityReportFooter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUtilityReportFooter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUtilityReportFooter(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    getHolidays(): Observable<Holiday[]> {
        let url_ = this.baseUrl + "/api/holidays";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Holiday[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Holiday[]>;
        }));
    }

    protected processGetHolidays(response: HttpResponseBase): Observable<Holiday[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Holiday[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Holiday[]>(null as any);
    }

    /**
     * @return OK
     */
    getHolidayById(holidayId: number): Observable<Holiday> {
        let url_ = this.baseUrl + "/api/holiday/{holidayId}";
        if (holidayId === undefined || holidayId === null)
            throw new Error("The parameter 'holidayId' must be defined.");
        url_ = url_.replace("{holidayId}", encodeURIComponent("" + holidayId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidayById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidayById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Holiday>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Holiday>;
        }));
    }

    protected processGetHolidayById(response: HttpResponseBase): Observable<Holiday> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Holiday;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Holiday>(null as any);
    }

    /**
     * @return No Content
     */
    deleteHoliday(holidayId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/holiday/{holidayId}";
        if (holidayId === undefined || holidayId === null)
            throw new Error("The parameter 'holidayId' must be defined.");
        url_ = url_.replace("{holidayId}", encodeURIComponent("" + holidayId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHoliday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteHoliday(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    saveHoliday(model: Holiday): Observable<Holiday> {
        let url_ = this.baseUrl + "/api/holiday/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveHoliday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Holiday>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Holiday>;
        }));
    }

    protected processSaveHoliday(response: HttpResponseBase): Observable<Holiday> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Holiday;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Holiday>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    getUsers(args: UserListArgs): Observable<PagedResultsOfUser> {
        let url_ = this.baseUrl + "/api/users/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfUser>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultsOfUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfUser;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfUser>(null as any);
    }

    /**
     * @return OK
     */
    getUser(userId: string): Observable<User> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as User;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<User>(null as any);
    }

    /**
     * @return OK
     */
    putUser(user: User): Observable<any> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processPutUser(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    addPortalUser(user: User): Observable<any> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPortalUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPortalUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAddPortalUser(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    logout(): Observable<any> {
        let url_ = this.baseUrl + "/api/users/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    setPassword(model: PasswordBindingModel): Observable<any> {
        let url_ = this.baseUrl + "/api/users/setPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSetPassword(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    initiatePasswordReset(model: PasswordResetModel): Observable<any> {
        let url_ = this.baseUrl + "/api/users/initiatePasswordReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitiatePasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitiatePasswordReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processInitiatePasswordReset(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    resetPassword(model: PasswordBindingModel): Observable<any> {
        let url_ = this.baseUrl + "/api/users/resetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    addUser(user: User): Observable<any> {
        let url_ = this.baseUrl + "/api/users/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    getAdminUsers(args: ListArgs): Observable<PagedResultsOfUser> {
        let url_ = this.baseUrl + "/api/users/getadminusers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfUser>;
        }));
    }

    protected processGetAdminUsers(response: HttpResponseBase): Observable<PagedResultsOfUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfUser;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfUser>(null as any);
    }

    /**
     * @return OK
     */
    getAdminUser(userId: string): Observable<User> {
        let url_ = this.baseUrl + "/api/users/getAdminUser?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processGetAdminUser(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as User;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<User>(null as any);
    }

    /**
     * @return OK
     */
    getAdminUserTeam(userId: string): Observable<FieldTeamLink> {
        let url_ = this.baseUrl + "/api/users/getAdminUserTeam?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminUserTeam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminUserTeam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldTeamLink>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldTeamLink>;
        }));
    }

    protected processGetAdminUserTeam(response: HttpResponseBase): Observable<FieldTeamLink> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FieldTeamLink;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldTeamLink>(null as any);
    }

    /**
     * @return OK
     */
    getAllRoles(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/users/getAllRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllRoles(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @return No Content
     */
    unlinkFieldWorker(fieldWorkerId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/users/unlinkFieldWorker?";
        if (fieldWorkerId === undefined || fieldWorkerId === null)
            throw new Error("The parameter 'fieldWorkerId' must be defined and cannot be null.");
        else
            url_ += "fieldWorkerId=" + encodeURIComponent("" + fieldWorkerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkFieldWorker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkFieldWorker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkFieldWorker(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    userPreferences(): Observable<{ [key: string]: Settings; }> {
        let url_ = this.baseUrl + "/api/users/preferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserPreferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserPreferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: Settings; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: Settings; }>;
        }));
    }

    protected processUserPreferences(response: HttpResponseBase): Observable<{ [key: string]: Settings; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: Settings; };
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: Settings; }>(null as any);
    }

    /**
     * @return OK
     */
    addOrUpdateUserPreferences(preferences: { [key: string]: Settings; }): Observable<{ [key: string]: Settings; }> {
        let url_ = this.baseUrl + "/api/users/preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preferences);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateUserPreferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateUserPreferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: Settings; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: Settings; }>;
        }));
    }

    protected processAddOrUpdateUserPreferences(response: HttpResponseBase): Observable<{ [key: string]: Settings; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: Settings; };
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: Settings; }>(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserRegistrationRequestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:61350";
    }

    /**
     * @return OK
     */
    userRegistrationRequests(args: UserRegistrationRequestListArgs): Observable<PagedResultsOfUserRegistrationRequest> {
        let url_ = this.baseUrl + "/api/userRegistrationRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserRegistrationRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserRegistrationRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsOfUserRegistrationRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsOfUserRegistrationRequest>;
        }));
    }

    protected processUserRegistrationRequests(response: HttpResponseBase): Observable<PagedResultsOfUserRegistrationRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultsOfUserRegistrationRequest;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultsOfUserRegistrationRequest>(null as any);
    }

    /**
     * @return OK
     */
    userRegistrationRequestCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/userRegistrationRequest/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserRegistrationRequestCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserRegistrationRequestCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUserRegistrationRequestCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return OK
     */
    getRegistrationRequest(registrationRequestId: number): Observable<User> {
        let url_ = this.baseUrl + "/api/userRegistrationRequest/{registrationRequestId}";
        if (registrationRequestId === undefined || registrationRequestId === null)
            throw new Error("The parameter 'registrationRequestId' must be defined.");
        url_ = url_.replace("{registrationRequestId}", encodeURIComponent("" + registrationRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processGetRegistrationRequest(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as User;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<User>(null as any);
    }

    /**
     * @return OK
     */
    userRegistrationRequest(userRegistrationRequest: UserRegistrationRequest): Observable<UserRegistrationRequest> {
        let url_ = this.baseUrl + "/api/userRegistrationRequest/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userRegistrationRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserRegistrationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserRegistrationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRegistrationRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRegistrationRequest>;
        }));
    }

    protected processUserRegistrationRequest(response: HttpResponseBase): Observable<UserRegistrationRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserRegistrationRequest;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRegistrationRequest>(null as any);
    }

    /**
     * @return OK
     */
    acceptUserRegistrationRequest(registrationRequestId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/userRegistrationRequest/accept/{registrationRequestId}";
        if (registrationRequestId === undefined || registrationRequestId === null)
            throw new Error("The parameter 'registrationRequestId' must be defined.");
        url_ = url_.replace("{registrationRequestId}", encodeURIComponent("" + registrationRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptUserRegistrationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptUserRegistrationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAcceptUserRegistrationRequest(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }

    /**
     * @return OK
     */
    denyUserRegistrationRequest(registrationRequestId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/userRegistrationRequest/deny/{registrationRequestId}";
        if (registrationRequestId === undefined || registrationRequestId === null)
            throw new Error("The parameter 'registrationRequestId' must be defined.");
        url_ = url_.replace("{registrationRequestId}", encodeURIComponent("" + registrationRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDenyUserRegistrationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDenyUserRegistrationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDenyUserRegistrationRequest(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(null as any);
    }
}

export interface PayrollBatch {
    id?: number | undefined;
    payPeriodEnd?: string | undefined;
    payrollType?: PayrollBatchPayrollType | undefined;
    status?: PayrollBatchStatus | undefined;
    submitted?: string | undefined;
    submittedBy?: string | undefined;
    lastStatusMessage?: string | undefined;
    dateBatchLastRan?: string | undefined;
    dwrs?: DwrFormSummary[] | undefined;
    paychecks?: PaycheckCandidate[] | undefined;
}

export interface DwrFormSummary {
    id?: number | undefined;
    source?: FieldWorkerLink | undefined;
    job?: JobLink | undefined;
    jobOverrides?: JobLink[] | undefined;
    railroadCode?: string | undefined;
    date?: string | undefined;
    typeOfDay?: DwrFormSummaryTypeOfDay | undefined;
    status?: FilledOutFormStatus | undefined;
    submittedOn?: string | undefined;
    reviewedOn?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
    payrollProcessed?: string | undefined;
    invoiceProcessed?: string | undefined;
    serviceType?: ServiceType | undefined;
    costCenters?: DwrCostCenter[] | undefined;
    isStandDownDay?: boolean | undefined;
    shift?: string | undefined;
}

export interface PaycheckCandidate {
    id?: number | undefined;
    status?: PaycheckCandidateStatus | undefined;
    payPeriodEnd?: string | undefined;
    forWorker?: FieldWorkerLink | undefined;
    workerPayrollType?: PaycheckCandidateWorkerPayrollType | undefined;
    workerRegularHourlyRate?: number | undefined;
    total?: number | undefined;
    isExcludedFromPayroll?: boolean | undefined;
    lineItems?: PaycheckLineItem[] | undefined;
    dailyWorkReports?: DwrFormSummary[] | undefined;
}

export interface FieldWorkerLink {
    id?: number | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    employeeCode?: string | undefined;
    paycomId?: string | undefined;
    jobTitle?: string | undefined;
    payrollType?: FieldWorkerLinkPayrollType | undefined;
    mealBreakAttestationSigned?: string | undefined;
    memberOfFieldTeamId?: number | undefined;
}

export interface JobLink {
    id?: number | undefined;
    number?: number | undefined;
    projectNumber?: string | undefined;
    description?: string | undefined;
}

export interface FilledOutFormStatus {
    id?: number | undefined;
    description?: string | undefined;
    sortOrder?: number | undefined;
}

export interface ServiceType {
    id?: number | undefined;
    description?: string | undefined;
    followsPrevailingWageRules?: boolean | undefined;
    showRwicSignatureAndDate?: boolean | undefined;
    allowTbdJobDates?: boolean | undefined;
    jobNumberSuffix?: string | undefined;
    doNotSendDwrEmailToJobClientRecipients?: boolean | undefined;
    doNotSendDwrEmailToFieldWorker?: boolean | undefined;
    excludeDwrsFromInvoiceBundle?: boolean | undefined;
    getsTrainerPay?: boolean | undefined;
    doNotPayOvertimeFor1099FieldWorkers?: boolean | undefined;
    travelTimeCalculationType?: ServiceTypeTravelTimeCalculationType | undefined;
}

export interface DwrCostCenter {
    id?: number | undefined;
    jobCostCenter?: JobCostCenter | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
}

export interface PaycheckLineItem {
    id?: number | undefined;
    countyWorkedIn?: string | undefined;
    stateWorkedIn?: string | undefined;
    description?: string | undefined;
    date?: string | undefined;
    duration?: string | undefined;
    type?: PaycheckLineItemType | undefined;
    units?: number | undefined;
    rate?: number | undefined;
    amount?: number | undefined;
    payCode?: string | undefined;
    deductionCode?: number | undefined;
    exportDescription?: string | undefined;
    note?: string | undefined;
    prevailingWageApplication?: PaycheckLineItemPrevailingWageApplication | undefined;
    rateType?: PaycheckLineItemRateType | undefined;
    sourceDwr?: DwrFormSummary | undefined;
    railroadCode?: string | undefined;
    stateLivedIn?: string | undefined;
    paycheckSummary?: PaycheckCandidateSummary | undefined;
}

export interface JobCostCenter {
    id?: number | undefined;
    job?: JobLink | undefined;
    code?: string | undefined;
    description?: string | undefined;
    milePostRange?: string | undefined;
}

export interface PaycheckCandidateSummary {
    id?: number | undefined;
    status?: PaycheckCandidateSummaryStatus | undefined;
    payPeriodEnd?: string | undefined;
    payrollType?: PaycheckCandidateSummaryPayrollType | undefined;
    forWorker?: FieldWorkerLink | undefined;
    workerPayrollType?: PaycheckCandidateSummaryWorkerPayrollType | undefined;
    total?: number | undefined;
    isExcludedFromPayroll?: boolean | undefined;
}

export interface PayrollBatchListArgs {
    firstPeriodEnd?: string | undefined;
    lastPeriodEnd?: string | undefined;
    payrollType?: PayrollBatchListArgsPayrollType | undefined;
    itemStatuses?: ItemStatuses[] | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface SortCriterion {
    sortKey?: string | undefined;
    isDescending?: boolean | undefined;
}

export interface PagedResultsOfPayrollBatchGroup {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: PayrollBatchGroup[] | undefined;
}

export interface PayrollBatchGroup {
    date?: string | undefined;
    status?: PayrollBatchGroupStatus | undefined;
    rpfsBatch?: PayrollBatchSummary | undefined;
    rpBatch?: PayrollBatchSummary | undefined;
    rwtBatch?: PayrollBatchSummary | undefined;
    as1099Batch?: PayrollBatchSummary | undefined;
    exemptDwrsForPrevailingWageJobs?: DwrFormSummary[] | undefined;
}

export interface PayrollBatchSummary {
    id?: number | undefined;
    payPeriodEnd?: string | undefined;
    payrollType?: PayrollBatchSummaryPayrollType | undefined;
    status?: PayrollBatchSummaryStatus | undefined;
    submitted?: string | undefined;
    submittedBy?: string | undefined;
    lastStatusMessage?: string | undefined;
    dateBatchLastRan?: string | undefined;
}

export interface PaycheckCandidateListArgs {
    firstPeriodEnd?: string | undefined;
    lastPeriodEnd?: string | undefined;
    payrollType?: PaycheckCandidateListArgsPayrollType | undefined;
    paycheckStatuses?: PaycheckStatuses[] | undefined;
    workerId?: number | undefined;
    payrollBatchId?: number | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfPaycheckCandidateSummary {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: PaycheckCandidateSummary[] | undefined;
}

export interface PayrollBatchRefreshRequest {
    date?: string | undefined;
    payrollType?: PayrollBatchRefreshRequestPayrollType | undefined;
}

export interface InvoiceCandidateListArgs {
    firstInvoiceDate?: string | undefined;
    lastInvoiceDate?: string | undefined;
    invoiceStatuses?: InvoiceStatuses[] | undefined;
    jobId?: number | undefined;
    customerId?: number | undefined;
    railroadId?: number | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfInvoiceCandidateSummary {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: InvoiceCandidateSummary[] | undefined;
}

export interface InvoiceCandidateSummary {
    id?: number | undefined;
    status?: InvoiceCandidateSummaryStatus | undefined;
    invoiceDate?: string | undefined;
    cutoffEndDate?: string | undefined;
    job?: JobLink | undefined;
    customer?: CustomerLink | undefined;
    railroad?: RailroadLink | undefined;
    number?: string | undefined;
    totalDwrs?: number | undefined;
    total?: number | undefined;
}

export interface CustomerLink {
    id?: number | undefined;
    name?: string | undefined;
    address?: string | undefined;
    billingEmail?: string | undefined;
    flairDocsCustomerId?: string | undefined;
}

export interface RailroadLink {
    id?: number | undefined;
    code?: string | undefined;
    name?: string | undefined;
    includeWcrReportInInvoice?: boolean | undefined;
    showWorkOrderNumberOnInvoice?: boolean | undefined;
    showAgreementNumberOnInvoice?: boolean | undefined;
    showReferenceNumber?: boolean | undefined;
    doesIncludeUtilityCoverSheet?: boolean | undefined;
    showProjectNumber?: boolean | undefined;
    showUpFolderNumber?: boolean | undefined;
    showNsActivityNumber?: boolean | undefined;
    showWorkOrderNumber?: boolean | undefined;
    favorDprsOverDwrs?: boolean | undefined;
    showTrackID?: boolean | undefined;
    showOrderNumber?: boolean | undefined;
    showRequiresJobSetups?: boolean | undefined;
    requireReportingForDuty?: boolean | undefined;
}

export interface InvoiceWithCutoffRequest {
    jobId?: number | undefined;
    cutoffEndDate?: string | undefined;
}

export interface InvoiceCandidate {
    id?: number | undefined;
    status?: InvoiceCandidateStatus | undefined;
    submitted?: string | undefined;
    submittedBy?: string | undefined;
    cutoffEndDate?: string | undefined;
    invoiceDate?: string | undefined;
    job?: JobLink | undefined;
    customer?: CustomerLink | undefined;
    railroad?: RailroadLink | undefined;
    number?: string | undefined;
    total?: number | undefined;
    lineItems?: InvoiceLineItem[] | undefined;
    otherCharges?: OtherChargeItem[] | undefined;
    dailyWorkReports?: DwrFormSummary[] | undefined;
    jobRates?: ContractRates[] | undefined;
    poNumber?: string | undefined;
    workOrderNumber?: string | undefined;
    preferredBillingChannel?: InvoiceCandidatePreferredBillingChannel | undefined;
    billToCompany?: string | undefined;
    billToAddress1?: string | undefined;
    billToAddress2?: string | undefined;
    billToCity?: string | undefined;
    billToState?: string | undefined;
    billToZipCode?: string | undefined;
    billToCountry?: string | undefined;
    bundled?: string | undefined;
    cachedInvoiceBlobId?: string | undefined;
    shiftsWithMissingDwrs?: JobShift[] | undefined;
}

export interface InvoiceLineItem {
    id?: number | undefined;
    chargeDate?: string | undefined;
    worker?: FieldWorkerLink | undefined;
    description?: string | undefined;
    units?: number | undefined;
    unitPrice?: number | undefined;
    amount?: number | undefined;
    type?: InvoiceLineItemType | undefined;
    note?: string | undefined;
    serviceType?: ServiceType | undefined;
    sourceDwr?: DwrFormSummary | undefined;
}

export interface OtherChargeItem {
    id?: number | undefined;
    chargeDate?: string | undefined;
    jobId?: number | undefined;
    description?: string | undefined;
    units?: number | undefined;
    unitPrice?: number | undefined;
    autoRenew?: boolean | undefined;
    readonly amount?: number | undefined;
    serviceType?: ServiceType | undefined;
}

export interface ContractRates {
    id?: number | undefined;
    standardDailyRate?: number | undefined;
    standardHourlyRate?: number | undefined;
    weeklyOvertimeThreshold?: number | undefined;
    overtimeHourlyRate?: number | undefined;
    nightDailyRate?: number | undefined;
    weekendDailyRate?: number | undefined;
    holidayDailyRate?: number | undefined;
    nightOvertimeHourlyRate?: number | undefined;
    weekendOvertimeHourlyRate?: number | undefined;
    holidayOvertimeHourlyRate?: number | undefined;
    initialMobilization?: number | undefined;
    remobilizationFee?: number | undefined;
    demobilization?: number | undefined;
    dailyMileageFee?: number | undefined;
    billActualMileage?: boolean | undefined;
    expeditedServiceFee?: number | undefined;
    processingAndHandlingFee?: number | undefined;
    certifiedPayrollFee?: number | undefined;
    railroadAdministrationFee?: number | undefined;
    perDiem?: number | undefined;
    isProcessingFeeMonthly?: boolean | undefined;
    isPayrollFeeMonthly?: boolean | undefined;
    isPayrollFeeWeekly?: boolean | undefined;
    standardDayLengthHours?: number | undefined;
    standDownDayRate?: number | undefined;
    notes?: string | undefined;
    serviceType?: ServiceType | undefined;
}

export interface JobShift {
    id?: number | undefined;
    job?: JobLink | undefined;
    rwic?: FieldWorkerLink | undefined;
    serviceType?: ServiceType | undefined;
    day?: string | undefined;
    startTime?: string | undefined;
    notes?: string | undefined;
    needsJobSetupForm?: boolean | undefined;
    reportedForDuty?: boolean | undefined;
}

export interface UtilityCoverSheetStatusResponse {
    readonly status?: UtilityCoverSheetStatusResponseStatus | undefined;
}

export interface AppInfoModel {
    companyName?: string | undefined;
    copyrightYear?: number | undefined;
    informationalVersion?: string | undefined;
    productName?: string | undefined;
    versionNumber?: string | undefined;
    versionNumberWithBuildNumber?: string | undefined;
}

export interface ApiRequestListArgs {
    resolutionTypes?: ResolutionTypes[] | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfApiRequest {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: ApiRequest[] | undefined;
}

export interface ApiRequest {
    id?: number | undefined;
    content?: string | undefined;
    resolution?: ApiRequestResolution | undefined;
}

export interface FlairDocsJobRequest {
    activityId?: string | undefined;
    customer?: FlairDocsCustomer | undefined;
    railroadCode?: string | undefined;
    description?: string | undefined;
    location?: string | undefined;
    startingMilePost?: string | undefined;
    endingMilePost?: string | undefined;
    notes?: string | undefined;
    start?: string | undefined;
    end?: string | undefined;
    fieldTeamId?: number | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    documents?: FlairDocsDocument[] | undefined;
    fieldContact?: FlairDocsContact | undefined;
    equipmentDescription?: string | undefined;
}

export interface FlairDocsCustomer {
    id?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
}

export interface FlairDocsDocument {
    title?: string | undefined;
    filename?: string | undefined;
    description?: string | undefined;
    bytes?: string | undefined;
}

export interface FlairDocsContact {
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    phoneExtension?: string | undefined;
    email?: string | undefined;
}

export interface TravelTime {
    id?: number | undefined;
    otssTravelTimeId?: string | undefined;
    employeeCode?: string | undefined;
    date?: string | undefined;
    travelToJobStartTime?: string | undefined;
    travelToJobEndTime?: string | undefined;
    hoursToJob?: number | undefined;
    travelFromJobStartTime?: string | undefined;
    travelFromJobEndTime?: string | undefined;
    hoursFromJob?: number | undefined;
    mileageToJob?: number | undefined;
    mileageOnJob?: number | undefined;
    mileagFromJob?: number | undefined;
}

export interface AuditTrailListArgs {
    objectType?: string | undefined;
    objectId?: number | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfAuditTrail {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: AuditTrail[] | undefined;
}

export interface AuditTrail {
    id?: number | undefined;
    eventType?: AuditTrailEventType | undefined;
    description?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    objectType?: string | undefined;
    objectId?: number | undefined;
    created?: string | undefined;
    modified?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    propertyName?: string | undefined;
}

export interface CustomerListArgs {
    railroadId?: number | undefined;
    fieldTeamId?: number | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfCustomer {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: Customer[] | undefined;
}

export interface Customer {
    id?: number | undefined;
    flairDocsCustomerId?: string | undefined;
    companyName?: string | undefined;
    employerIdentificationNumber?: string | undefined;
    contractedRates?: ContractRates | undefined;
    billingEmail?: string | undefined;
    address?: Address | undefined;
    contacts?: Contact[] | undefined;
    documents?: Document[] | undefined;
}

export interface Address {
    id?: number | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    country?: string | undefined;
    description?: string | undefined;
}

export interface Contact {
    id?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: string | undefined;
    phoneNumbers?: PhoneNumber[] | undefined;
    emailAddresses?: EmailAddress[] | undefined;
}

export interface Document {
    id?: number | undefined;
    title?: string | undefined;
    fileName?: string | undefined;
    description?: string | undefined;
    uploadedOn?: string | undefined;
    timeStamp?: string | undefined;
    tags?: string[] | undefined;
    sizeInBytes?: number | undefined;
    hideFromCustomer?: boolean | undefined;
    hideFromFieldWorker?: boolean | undefined;
    includeInInvoicing?: boolean | undefined;
}

export interface PhoneNumber {
    id?: number | undefined;
    description?: string | undefined;
    countryCode?: string | undefined;
    areaCode?: string | undefined;
    number?: string | undefined;
    extension?: string | undefined;
    isPrimary?: boolean | undefined;
}

export interface EmailAddress {
    id?: number | undefined;
    description?: string | undefined;
    email?: string | undefined;
    isPrimary?: boolean | undefined;
}

export interface NewDocumentRequest {
    parentId?: number | undefined;
    title?: string | undefined;
    fileName?: string | undefined;
    description?: string | undefined;
    timeStamp?: string | undefined;
    attributes?: string[] | undefined;
    data?: string | undefined;
    hideFromCustomer?: boolean | undefined;
    hideFromFieldWorker?: boolean | undefined;
    includeInInvoicing?: boolean | undefined;
}

export interface Company {
    id?: number | undefined;
    name?: string | undefined;
    employerIdentificationNumber?: string | undefined;
    contacts?: Contact[] | undefined;
    address?: Address | undefined;
}

export interface RailroadListArgs {
    customerId?: number | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfRailroad {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: Railroad[] | undefined;
}

export interface Railroad {
    id?: number | undefined;
    companyName?: string | undefined;
    code?: string | undefined;
    publicDwrStyle?: RailroadPublicDwrStyle | undefined;
    nonflaggingHourlyRate?: number | undefined;
    conferenceCallHourlyRate?: number | undefined;
    trainingHourlyRate?: number | undefined;
    travelHourlyRate?: number | undefined;
    drugTestHourlyRate?: number | undefined;
    dailyCellPhoneReimbursementRate?: number | undefined;
    hotelPerDiemA?: number | undefined;
    mealPerDiemA?: number | undefined;
    hotelPerDiemB?: number | undefined;
    mealPerDiemB?: number | undefined;
    mealBonusApplies?: boolean | undefined;
    mileageReimbursed?: boolean | undefined;
    travelTimeApplies?: boolean | undefined;
    minimumShiftHours?: number | undefined;
    includeWcrReportInInvoice?: boolean | undefined;
    favorDprsOverDwrs?: boolean | undefined;
    divisionLabel?: string | undefined;
    contractNumber?: string | undefined;
    taskNumber?: string | undefined;
    dailyVehicleFee?: number | undefined;
    weeklyVehicleFee?: number | undefined;
    monthlyVehicleFee?: number | undefined;
    employerIdentificationNumber?: string | undefined;
    address?: Address | undefined;
    contacts?: Contact[] | undefined;
    documents?: Document[] | undefined;
    divisions?: Division[] | undefined;
    billingEmail?: string | undefined;
    dwrTemplate?: FormTemplateLink | undefined;
    jobSetupTemplate?: FormTemplateLink | undefined;
    requiredCertifications?: RequiredCertification[] | undefined;
    offeredServices?: OfferedService[] | undefined;
    subCodes?: RailroadSubCode[] | undefined;
    contractedRates?: ContractRates[] | undefined;
    showProjectManagerName?: boolean | undefined;
    showProjectNumber?: boolean | undefined;
    showWorkOrderNumber?: boolean | undefined;
    showTermsAndConditions?: boolean | undefined;
    showIsSupervisorJob?: boolean | undefined;
    showNetworkOrServiceOrder?: boolean | undefined;
    showIsThirdPartyJob?: boolean | undefined;
    showAgreementNumber?: boolean | undefined;
    showUpFolderNumber?: boolean | undefined;
    showNsActivityNumber?: boolean | undefined;
    showProtection?: boolean | undefined;
    showReferenceNumber?: boolean | undefined;
    showTrackID?: boolean | undefined;
    showOrderNumber?: boolean | undefined;
    showRequiresJobSetups?: boolean | undefined;
    dwrType?: RailroadDwrType | undefined;
    overtimeBasis?: RailroadOvertimeBasis | undefined;
    regularTimeBasis?: RailroadRegularTimeBasis | undefined;
    areCostCentersEnabled?: boolean | undefined;
    isIntegratedWithFlairDocs?: boolean | undefined;
    doesIncludeUtilityCoverSheet?: boolean | undefined;
    showWorkOrderNumberOnInvoice?: boolean | undefined;
    requireReportingForDuty?: boolean | undefined;
    class?: RailroadClass | undefined;
}

export interface Division {
    id?: number | undefined;
    name?: string | undefined;
    status?: DivisionStatus | undefined;
    isAssignedToAJob?: boolean | undefined;
    subdivisions?: Subdivision[] | undefined;
}

export interface FormTemplateLink {
    id?: number | undefined;
    name?: string | undefined;
}

export interface RequiredCertification {
    id?: number | undefined;
    description?: string | undefined;
    railroad?: RailroadLink | undefined;
    certificationType?: CertificationType | undefined;
    isNotRailroadSpecific?: boolean | undefined;
}

export interface OfferedService {
    id?: number | undefined;
    name?: string | undefined;
    type?: ServiceType | undefined;
    railroad?: RailroadLink | undefined;
    isActive?: boolean | undefined;
}

export interface RailroadSubCode {
    id?: number | undefined;
    railroad?: RailroadLink | undefined;
    code?: string | undefined;
    sortOrder?: number | undefined;
}

export interface Subdivision {
    id?: number | undefined;
    name?: string | undefined;
    status?: SubdivisionStatus | undefined;
    isAssignedToAJob?: boolean | undefined;
}

export interface CertificationType {
    id?: number | undefined;
    name?: string | undefined;
}

export interface RailroadQuoteTemplate {
    id?: number | undefined;
    name?: string | undefined;
    railroad?: RailroadLink | undefined;
    binaryId?: number | undefined;
}

export interface DivisionLink {
    id?: number | undefined;
    name?: string | undefined;
}

export interface SubdivisionLink {
    id?: number | undefined;
    name?: string | undefined;
}

export interface ValueTupleOfBinaryAndString {
    item1?: Binary | undefined;
    item2?: string | undefined;
}

export interface Binary {
    id?: number | undefined;
    azureBlobId?: string | undefined;
    bytes?: string | undefined;
}

export interface DwrListArgs {
    fieldTeamId?: number | undefined;
    serviceTypeId?: number | undefined;
    dayClassifications?: DayClassifications[] | undefined;
    payrollTypes?: PayrollTypes[] | undefined;
    fieldWorkerId?: number | undefined;
    jobId?: number | undefined;
    railroadId?: number | undefined;
    start?: string | undefined;
    end?: string | undefined;
    isWithinJobDates?: boolean | undefined;
    filledOutFormStatusIds?: number[] | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfDwrFormSummary {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: DwrFormSummary[] | undefined;
}

export interface DwrForm {
    id?: number | undefined;
    source?: FieldWorkerLink | undefined;
    job?: JobLink | undefined;
    railroad?: RailroadLink | undefined;
    date?: string | undefined;
    typeOfDay?: DwrFormTypeOfDay | undefined;
    nonBillableDayReason?: DwrFormNonBillableDayReason | undefined;
    travelTime?: TravelTime | undefined;
    billOvertimeToOtherShift?: boolean | undefined;
    isLateCancellation?: boolean | undefined;
    isTrainer?: boolean | undefined;
    isStandDownDay?: boolean | undefined;
    railroadSignature?: string | undefined;
    railroadSignatureDate?: string | undefined;
    rwicSignature?: string | undefined;
    rwicSignatureDate?: string | undefined;
    clientSignature?: string | undefined;
    clientSignatureDate?: string | undefined;
    clientSignerName?: string | undefined;
    clientSignerPhone?: string | undefined;
    clientSignerEmail?: string | undefined;
    companyName?: string | undefined;
    title?: string | undefined;
    instructions?: string | undefined;
    filledOutFormId?: number | undefined;
    template?: FormTemplateLink | undefined;
    status?: FilledOutFormStatus | undefined;
    submittedOn?: string | undefined;
    reviewNotes?: string | undefined;
    reviewedOn?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
    paycheck?: PaycheckCandidateSummary | undefined;
    payrollProcessed?: string | undefined;
    payrollBatch?: PayrollBatchSummary | undefined;
    invoice?: InvoiceCandidateSummary | undefined;
    invoiceProcessed?: string | undefined;
    serviceType?: ServiceType | undefined;
    jobOverrides?: JobLink[] | undefined;
    fields?: FormFieldResponse[] | undefined;
    costCenters?: DwrCostCenter[] | undefined;
    odometerCaptures?: OdometerCapture[] | undefined;
    ignoreForPayroll?: boolean | undefined;
}

export interface FormFieldResponse {
    id?: number | undefined;
    isNotApplicable?: boolean | undefined;
    response?: string | undefined;
    formattedResponse?: string | undefined;
    formFieldPlacementId?: number | undefined;
    isRequired?: boolean | undefined;
    isLockedStatus?: FormFieldResponseIsLockedStatus | undefined;
    group?: number | undefined;
    prompt?: string | undefined;
    options?: string[] | undefined;
    instructions?: string | undefined;
    type?: FormFieldResponseType | undefined;
    usageCode?: string | undefined;
    parentUsageCode?: string | undefined;
}

export interface OdometerCapture {
    id?: number | undefined;
    rawValue?: number | undefined;
    userEnteredValue?: number | undefined;
    confidenceScore?: number | undefined;
    captureStatus?: OdometerCaptureCaptureStatus | undefined;
    captureKind?: OdometerCaptureCaptureKind | undefined;
    captureSource?: OdometerCaptureCaptureSource | undefined;
    failureReason?: string | undefined;
    modelName?: string | undefined;
    promptKey?: string | undefined;
    dwrHeaderId?: number | undefined;
    enqueuedAt?: string | undefined;
    processingStartedAt?: string | undefined;
    processingCompletedAt?: string | undefined;
    fullImage?: Binary | undefined;
    croppedImage?: Binary | undefined;
    readonly odometerValue?: number | undefined;
}

export interface DailyFormInfoRequest {
    start?: string | undefined;
    end?: string | undefined;
    jobId?: number | undefined;
    railroadId?: number | undefined;
}

export interface DailyFormCounts {
    jobId?: number | undefined;
    date?: string | undefined;
    expected?: number | undefined;
    inReview?: number | undefined;
    inRevision?: number | undefined;
    resubmitted?: number | undefined;
    approved?: number | undefined;
    unexpected?: number | undefined;
}

export interface DailyOutOfJobRangeCount {
    job?: JobSummary | undefined;
    railroad?: RailroadLink | undefined;
    count?: OutOfJobRangeCounts[] | undefined;
}

export interface JobSummary {
    id?: number | undefined;
    number?: number | undefined;
    description?: string | undefined;
    status?: JobSummaryStatus | undefined;
    quoteStatus?: JobSummaryQuoteStatus | undefined;
    lastModified?: string | undefined;
    customer?: CustomerLink | undefined;
    railroad?: RailroadLink | undefined;
    team?: FieldTeamLink | undefined;
    start?: string | undefined;
    end?: string | undefined;
    approvalDate?: string | undefined;
    poNumber?: string | undefined;
    upFolderNumber?: string | undefined;
    isPrevailingWage?: boolean | undefined;
    nsActivityNumber?: string | undefined;
    projectNumber?: string | undefined;
    offeredServices?: OfferedService[] | undefined;
    permitNumber?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    orderNumber?: string | undefined;
    trackID?: JobSummaryTrackID | undefined;
    referenceNumber?: string | undefined;
}

export interface OutOfJobRangeCounts {
    date?: string | undefined;
    inReview?: number | undefined;
    inRevision?: number | undefined;
    resubmitted?: number | undefined;
    approved?: number | undefined;
}

export interface FieldTeamLink {
    id?: number | undefined;
    name?: string | undefined;
    fieldManager?: FieldWorkerLink | undefined;
}

export interface DailyFormDetailsOfDwrFormSummary {
    jobId?: number | undefined;
    date?: string | undefined;
    missing?: JobShift[] | undefined;
    unexpectedNeedsReview?: DwrFormSummary[] | undefined;
    expectedNeedsReview?: DwrFormSummary[] | undefined;
    inRevision?: DwrFormSummary[] | undefined;
    approved?: DwrFormSummary[] | undefined;
}

export interface BulkDwrApprovalCheckRequest {
    dwrIds?: number[] | undefined;
}

export interface ChangedDwrDatesResponse {
    data?: { [key: string]: string; } | undefined;
    queryTime?: string | undefined;
}

export interface DwrDataDrivenFormViewModel {
    title?: string | undefined;
    description?: string | undefined;
    railroadId?: number | undefined;
    serviceTypeId?: number | undefined;
    typeOfDay?: DwrDataDrivenFormViewModelTypeOfDay | undefined;
    nonBillableDayReason?: DwrDataDrivenFormViewModelNonBillableDayReason | undefined;
    formTemplateId?: number | undefined;
    fields?: DataDrivenFormField[] | undefined;
}

export interface DataDrivenFormField {
    component?: string | undefined;
    name?: string | undefined;
    clearedValue?: string | undefined;
    condition?: any | undefined;
    hideField?: boolean | undefined;
    initialValue?: string | undefined;
    usageCode?: string | undefined;
    validate?: IValidation[] | undefined;
    fields?: DataDrivenFormField[] | undefined;
    formPlacementId?: string | undefined;
    label?: string | undefined;
    options?: DataDrivenFormFieldOption[] | undefined;
    sectionType?: string | undefined;
}

export interface IValidation {
    type?: string | undefined;
    message?: string | undefined;
}

export interface DataDrivenFormFieldOption {
    label?: string | undefined;
    value?: string | undefined;
}

export interface DwrSubmissionViewModel {
    responses?: { [key: string]: string; } | undefined;
    dwrHeaderId?: number | undefined;
    status?: FilledOutFormStatus | undefined;
    typeOfDay?: DwrSubmissionViewModelTypeOfDay | undefined;
    nonBillableReason?: DwrSubmissionViewModelNonBillableReason | undefined;
    railroad?: number | undefined;
    serviceType?: number | undefined;
    formTemplateId?: number | undefined;
    fieldworker?: FieldWorkerLink | undefined;
}

export interface SaveFormMobileResponse {
    status?: number | undefined;
    errorMsg?: string | undefined;
}

export interface DwrDayClassificationViewModel {
    typeOfDay?: DwrDayClassificationViewModelTypeOfDay | undefined;
    label?: string | undefined;
}

export interface NonbillableReasonViewModel {
    reason?: NonbillableReasonViewModelReason | undefined;
    label?: string | undefined;
}

export interface JobSetupFormListArgs {
    fieldTeamId?: number | undefined;
    fieldWorkerId?: number | undefined;
    jobId?: number | undefined;
    railroadId?: number | undefined;
    start?: string | undefined;
    end?: string | undefined;
    isWithinJobDates?: boolean | undefined;
    filledOutFormStatusIds?: number[] | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfJobSetupFormSummary {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: JobSetupFormSummary[] | undefined;
}

export interface JobSetupFormSummary {
    id?: number | undefined;
    rwic?: FieldWorkerLink | undefined;
    job?: JobLink | undefined;
    date?: string | undefined;
    status?: FilledOutFormStatus | undefined;
    submittedOn?: string | undefined;
    reviewedOn?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
}

export interface JobSetupForm {
    id?: number | undefined;
    job?: JobLink | undefined;
    rwic?: FieldWorkerLink | undefined;
    railroad?: RailroadLink | undefined;
    date?: string | undefined;
    rwicSignature?: string | undefined;
    rwicSignatureDate?: string | undefined;
    title?: string | undefined;
    instructions?: string | undefined;
    filledOutFormId?: number | undefined;
    template?: FormTemplateLink | undefined;
    status?: FilledOutFormStatus | undefined;
    submittedOn?: string | undefined;
    reviewNotes?: string | undefined;
    reviewedOn?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
    serviceType?: ServiceType | undefined;
    fields?: FormFieldResponse[] | undefined;
}

export interface DailyFormDetailsOfJobSetupFormSummary {
    jobId?: number | undefined;
    date?: string | undefined;
    missing?: JobShift[] | undefined;
    unexpectedNeedsReview?: JobSetupFormSummary[] | undefined;
    expectedNeedsReview?: JobSetupFormSummary[] | undefined;
    inRevision?: JobSetupFormSummary[] | undefined;
    approved?: JobSetupFormSummary[] | undefined;
}

export interface JobSetupDataDrivenFormViewModel {
    title?: string | undefined;
    description?: string | undefined;
    railroadId?: number | undefined;
    serviceTypeId?: number | undefined;
    formTemplateId?: number | undefined;
    fields?: DataDrivenFormField[] | undefined;
}

export interface JobSetupSubmissionViewModel {
    responses?: { [key: string]: string; } | undefined;
    jobSetupHeaderId?: number | undefined;
    status?: FilledOutFormStatus | undefined;
    railroad?: number | undefined;
    serviceType?: number | undefined;
    formTemplateId?: number | undefined;
    fieldworker?: FieldWorkerLink | undefined;
}

export interface UtilityCoverSheetListArgs {
    fieldTeamId?: number | undefined;
    fieldWorkerId?: number | undefined;
    jobId?: number | undefined;
    railroadId?: number | undefined;
    start?: string | undefined;
    end?: string | undefined;
    isWithinJobDates?: boolean | undefined;
    filledOutFormStatusIds?: number[] | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfUtilityCoverSheetSummary {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: UtilityCoverSheetSummary[] | undefined;
}

export interface UtilityCoverSheetSummary {
    id?: number | undefined;
    rwic?: FieldWorkerLink | undefined;
    job?: JobLink | undefined;
    date?: string | undefined;
    status?: FilledOutFormStatus | undefined;
    submittedOn?: string | undefined;
    reviewedOn?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
}

export interface UtilityCoverSheet {
    id?: number | undefined;
    job?: JobLink | undefined;
    rwic?: FieldWorkerLink | undefined;
    date?: string | undefined;
    rwicSignature?: string | undefined;
    rwicSignatureDate?: string | undefined;
    title?: string | undefined;
    instructions?: string | undefined;
    filledOutFormId?: number | undefined;
    template?: FormTemplateLink | undefined;
    status?: FilledOutFormStatus | undefined;
    submittedOn?: string | undefined;
    reviewNotes?: string | undefined;
    reviewedOn?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
    fields?: FormFieldResponse[] | undefined;
    cachedMapImageBlobId?: string | undefined;
    invoiceCandidateId?: number | undefined;
}

export interface UtilityCoverSheetViewModel {
    id?: number | undefined;
    job?: JobLink | undefined;
    rwic?: FieldWorkerLink | undefined;
    date?: string | undefined;
    rwicSignature?: string | undefined;
    rwicSignatureDate?: string | undefined;
    title?: string | undefined;
    instructions?: string | undefined;
    filledOutFormId?: number | undefined;
    template?: FormTemplateLink | undefined;
    status?: FilledOutFormStatus | undefined;
    submittedOn?: string | undefined;
    reviewNotes?: string | undefined;
    reviewedOn?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
    sections?: Section[] | undefined;
    cachedMapImageBlobId?: string | undefined;
    invoiceCandidateId?: number | undefined;
}

export interface Section {
    description?: string | undefined;
    sectionType?: SectionType | undefined;
    headerType?: SectionHeaderType | undefined;
    sectionResponse?: FormFieldResponse | undefined;
    subSections?: Section[] | undefined;
    fields?: FormFieldResponse[] | undefined;
}

export interface UtilityJobSetupFormListArgs {
    fieldTeamId?: number | undefined;
    fieldWorkerId?: number | undefined;
    jobId?: number | undefined;
    railroadId?: number | undefined;
    start?: string | undefined;
    end?: string | undefined;
    isWithinJobDates?: boolean | undefined;
    filledOutFormStatusIds?: number[] | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfUtilityJobSetupFormSummary {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: UtilityJobSetupFormSummary[] | undefined;
}

export interface UtilityJobSetupFormSummary {
    id?: number | undefined;
    rwic?: FieldWorkerLink | undefined;
    job?: JobLink | undefined;
    date?: string | undefined;
    status?: FilledOutFormStatus | undefined;
    submittedOn?: string | undefined;
    reviewedOn?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
}

export interface UtilityJobSetupForm {
    id?: number | undefined;
    job?: JobLink | undefined;
    rwic?: FieldWorkerLink | undefined;
    date?: string | undefined;
    rwicSignature?: string | undefined;
    rwicSignatureDate?: string | undefined;
    title?: string | undefined;
    instructions?: string | undefined;
    filledOutFormId?: number | undefined;
    template?: FormTemplateLink | undefined;
    status?: FilledOutFormStatus | undefined;
    submittedOn?: string | undefined;
    reviewNotes?: string | undefined;
    reviewedOn?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
    fields?: FormFieldResponse[] | undefined;
}

export interface UtilityJobSetupFormViewModel {
    id?: number | undefined;
    job?: JobLink | undefined;
    rwic?: FieldWorkerLink | undefined;
    date?: string | undefined;
    rwicSignature?: string | undefined;
    rwicSignatureDate?: string | undefined;
    title?: string | undefined;
    instructions?: string | undefined;
    filledOutFormId?: number | undefined;
    template?: FormTemplateLink | undefined;
    status?: FilledOutFormStatus | undefined;
    submittedOn?: string | undefined;
    reviewNotes?: string | undefined;
    reviewedOn?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
    sections?: Section[] | undefined;
}

export interface SafetyAuditListArgs {
    fieldWorkerId?: number | undefined;
    start?: string | undefined;
    end?: string | undefined;
    filledOutFormStatusIds?: number[] | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfSafetyAuditFormSummary {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: SafetyAuditFormSummary[] | undefined;
}

export interface SafetyAuditFormSummary {
    id?: number | undefined;
    rwic?: FieldWorkerLink | undefined;
    date?: string | undefined;
    status?: FilledOutFormStatus | undefined;
    submittedOn?: string | undefined;
    reviewedOn?: string | undefined;
}

export interface SafetyAuditForm {
    id?: number | undefined;
    rwic?: FieldWorkerLink | undefined;
    date?: string | undefined;
    title?: string | undefined;
    instructions?: string | undefined;
    filledOutFormId?: number | undefined;
    template?: FormTemplateLink | undefined;
    status?: FilledOutFormStatus | undefined;
    submittedOn?: string | undefined;
    reviewNotes?: string | undefined;
    reviewedOn?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
    fields?: FormFieldResponse[] | undefined;
}

export interface FormTemplateListArgs {
    typeId?: number | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfFormTemplateSummary {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: FormTemplateSummary[] | undefined;
}

export interface FormTemplateSummary {
    id?: number | undefined;
    name?: string | undefined;
    title?: string | undefined;
    type?: FormType | undefined;
    numberOfQuestions?: number | undefined;
}

export interface FormType {
    id?: number | undefined;
    description?: string | undefined;
    sortOrder?: number | undefined;
}

export interface FormTemplate {
    id?: number | undefined;
    type?: FormType | undefined;
    name?: string | undefined;
    title?: string | undefined;
    instructions?: string | undefined;
    fields?: FormFieldPlacement[] | undefined;
}

export interface FormFieldPlacement {
    id?: number | undefined;
    template?: FormTemplateLink | undefined;
    field?: FormField | undefined;
    section?: FormSection | undefined;
    isRequired?: boolean | undefined;
    group?: number | undefined;
    note?: string | undefined;
    usageCode?: string | undefined;
    isDeprecated?: boolean | undefined;
    parentUsageCode?: string | undefined;
    condition?: any | undefined;
}

export interface FormField {
    id?: number | undefined;
    type?: FormFieldType | undefined;
    prompt?: string | undefined;
    instructions?: string | undefined;
    options?: string[] | undefined;
}

export interface FormSection {
    id?: number | undefined;
    name?: string | undefined;
    parentSectionId?: number | undefined;
    sectionType?: FormSectionSectionType | undefined;
    sortOrder?: number | undefined;
    condition?: any | undefined;
    children?: FormSection[] | undefined;
}

export interface FlashAuditListArgs {
    statuses?: Statuses[] | undefined;
    fieldTeamId?: number | undefined;
    rwicId?: number | undefined;
    reviewerId?: number | undefined;
    timestampRangeStart?: string | undefined;
    timestampRangeEnd?: string | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfFlashAuditSummary {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: FlashAuditSummary[] | undefined;
}

export interface FlashAuditSummary {
    id?: number | undefined;
    rwic?: FieldWorkerLink | undefined;
    timestamp?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
    reviewNotes?: string | undefined;
    reviewedOn?: string | undefined;
    status?: FlashAuditSummaryStatus | undefined;
    images?: FlashAuditImageSummary[] | undefined;
}

export interface FlashAuditImageSummary {
    id?: number | undefined;
    timestamp?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export interface FlashAudit {
    id?: number | undefined;
    rwic?: FieldWorkerLink | undefined;
    timestamp?: string | undefined;
    reviewer?: FieldWorkerLink | undefined;
    reviewNotes?: string | undefined;
    reviewedOn?: string | undefined;
    status?: FlashAuditStatus | undefined;
    images?: FlashAuditImage[] | undefined;
}

export interface FlashAuditImage {
    id?: number | undefined;
    timestamp?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    data?: string | undefined;
}

export interface JobListArgs {
    teamId?: number | undefined;
    customerId?: number | undefined;
    divisionId?: number | undefined;
    subdivisionId?: number | undefined;
    rwicId?: number | undefined;
    railroadId?: number | undefined;
    serviceTypeId?: number | undefined;
    filterByApprovalDate?: boolean | undefined;
    jobStatuses?: JobStatuses[] | undefined;
    billingStatus?: JobListArgsBillingStatus | undefined;
    payrollStatus?: JobListArgsPayrollStatus | undefined;
    quoteStatus?: JobListArgsQuoteStatus | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfJobSummary {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: JobSummary[] | undefined;
}

export interface BillableJobListArgs {
    readyToInvoice?: boolean | undefined;
    notReadyToInvoice?: boolean | undefined;
    customerId?: number | undefined;
    railroadId?: number | undefined;
    endDate?: string | undefined;
    serviceTypeId?: number | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfBillableJobSummary {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: BillableJobSummary[] | undefined;
}

export interface BillableJobSummary {
    id?: number | undefined;
    number?: number | undefined;
    description?: string | undefined;
    status?: BillableJobSummaryStatus | undefined;
    lastModified?: string | undefined;
    customer?: CustomerLink | undefined;
    railroad?: RailroadLink | undefined;
    team?: FieldTeamLink | undefined;
    missingDwrs?: number | undefined;
    unapprovedDwrs?: number | undefined;
    approvedDwrs?: number | undefined;
    totalDwrs?: number | undefined;
    start?: string | undefined;
    end?: string | undefined;
    poNumber?: string | undefined;
    isPrevailingWage?: boolean | undefined;
    serviceTypes?: string | undefined;
}

export interface FullyInvoicedJobsRequest {
    customerId?: number | undefined;
    startOfMonth?: string | undefined;
}

export interface InvoicedJobSummary {
    id?: number | undefined;
    number?: string | undefined;
    description?: string | undefined;
    end?: string | undefined;
    poNumber?: string | undefined;
    isBundled?: boolean | undefined;
}

export interface Job {
    id?: number | undefined;
    flairDocsJobId?: string | undefined;
    customer?: CustomerLink | undefined;
    railroad?: RailroadLink | undefined;
    number?: number | undefined;
    description?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    location?: string | undefined;
    startingMilePost?: string | undefined;
    endingMilePost?: string | undefined;
    notes?: string | undefined;
    billingNotes?: string | undefined;
    readonly dateRange?: DateRange | undefined;
    start?: string | undefined;
    end?: string | undefined;
    approvalDate?: string | undefined;
    originatingPortalUserEmail?: string | undefined;
    quoteNotificationRecipients?: string[] | undefined;
    dwrNotificationRecipients?: string[] | undefined;
    jobSetupFormRefreshDate?: string | undefined;
    division?: Division | undefined;
    subdivision?: Subdivision | undefined;
    team?: FieldTeamLink | undefined;
    workOrderNumber?: string | undefined;
    projectNumber?: string | undefined;
    projectManagerName?: string | undefined;
    termsAndConditions?: string | undefined;
    agreementNumber?: string | undefined;
    isSupervisorJob?: boolean | undefined;
    isThirdPartyJob?: boolean | undefined;
    upFolderNumber?: string | undefined;
    nsActivityNumber?: string | undefined;
    protection?: string | undefined;
    referenceNumber?: string | undefined;
    orderNumber?: string | undefined;
    requiresJobSetups?: boolean | undefined;
    trackID?: JobTrackID | undefined;
    status?: JobStatus | undefined;
    dateCompleted?: string | undefined;
    quoteStatus?: JobQuoteStatus | undefined;
    billingEmails?: string[] | undefined;
    trackSupervisor?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    descriptionOfSchedule?: string | undefined;
    equipmentDescription?: string | undefined;
    distanceFromTracks?: string | undefined;
    permitNumber?: string | undefined;
    isSafetyTrainingComplete?: boolean | undefined;
    poNumber?: string | undefined;
    preferredBillingChannel?: JobPreferredBillingChannel | undefined;
    billTo?: JobBillTo | undefined;
    otherBillingCompany?: Company | undefined;
    alternateBillingCustomer?: CustomerLink | undefined;
    lastInvoiceCutoffDate?: string | undefined;
    prevailingWageInfo?: PrevailingWageInfo | undefined;
    documents?: Document[] | undefined;
    assignments?: JobAssignment[] | undefined;
    unassignedShifts?: JobShift[] | undefined;
    contractedRates?: ContractRates[] | undefined;
    fieldContacts?: Contact[] | undefined;
    poAmount?: number | undefined;
    alertAmount?: number | undefined;
    estimatedSpend?: number | undefined;
    alertThresholdPercentage?: number | undefined;
    alertEmailAddresses?: string[] | undefined;
    overTimeBasis?: JobOverTimeBasis | undefined;
    regularTimeBasis?: JobRegularTimeBasis | undefined;
    party?: JobParty | undefined;
    jobType?: JobType | undefined;
    endMarket?: JobEndMarket | undefined;
    daysRequested?: number | undefined;
    networkOrServiceOrder?: JobNetworkOrServiceOrder | undefined;
    railroadSubCode?: RailroadSubCode | undefined;
    offeredServices?: OfferedService[] | undefined;
    isNonBillable?: boolean | undefined;
}

export interface DateRange {
    begin?: string | undefined;
    end?: string | undefined;
}

export interface PrevailingWageInfo {
    id?: number | undefined;
    projectName?: string | undefined;
    projectNumber?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    state?: string | undefined;
    certifiedPayrollReportsRequired?: boolean | undefined;
    payrollReportsName?: string | undefined;
    payrollReportsPhone?: string | undefined;
    payrollReportsEmail?: string | undefined;
    confirmedBy?: string | undefined;
    confirmedDate?: string | undefined;
    pw1Rate?: number | undefined;
    pw2Rate?: number | undefined;
    pw3Rate?: number | undefined;
    pw1NightShiftRate?: number | undefined;
    pw2NightShiftRate?: number | undefined;
    pw3NightShiftRate?: number | undefined;
}

export interface JobAssignment {
    job?: JobSummary | undefined;
    rwic?: FieldWorkerLink | undefined;
    start?: string | undefined;
    end?: string | undefined;
    fieldContactName?: string | undefined;
    fieldContactPhone?: string | undefined;
    fieldContactEmail?: string | undefined;
    location?: string | undefined;
    milepost?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    shifts?: JobShift[] | undefined;
}

export interface JobSummaryMobile {
    jobId?: number | undefined;
    number?: number | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    description?: string | undefined;
    notes?: string | undefined;
    equipmentDescription?: string | undefined;
    distanceFromTracks?: string | undefined;
    trackSupervisor?: string | undefined;
    permitNumber?: string | undefined;
    startingMilePost?: string | undefined;
    location?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    city?: string | undefined;
    state?: string | undefined;
    contacts?: Contact[] | undefined;
    documents?: DocumentMobileViewModel[] | undefined;
    railroad?: RailroadLink | undefined;
    lastJobSetupSubmissionDate?: string | undefined;
    requiresJobSetups?: boolean | undefined;
    folderNumber?: string | undefined;
    activityNumber?: string | undefined;
    projectNumber?: string | undefined;
    workOrderNumber?: string | undefined;
    referenceNumber?: string | undefined;
    trackID?: JobSummaryMobileTrackID | undefined;
}

export interface DocumentMobileViewModel {
    id?: number | undefined;
    title?: string | undefined;
    fileName?: string | undefined;
}

export interface ConfirmPrevailingWageResponse {
    confirmedBy?: string | undefined;
    confirmedDate?: string | undefined;
}

export interface JobShiftListArgs {
    fieldWorkerId?: number | undefined;
    jobId?: number | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    railroadId?: number | undefined;
    onlyForBillableJobs?: boolean | undefined;
    excludeContractors?: boolean | undefined;
    serviceTypeIds?: number[] | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfJobAssignment {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: JobAssignment[] | undefined;
}

export interface PagedResultsOfJobShift {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: JobShift[] | undefined;
}

export interface QuoteListArgs {
    actions?: Actions[] | undefined;
    submissionStartDate?: string | undefined;
    submissionEndDate?: string | undefined;
    railroadId?: number | undefined;
    customerId?: number | undefined;
    jobId?: number | undefined;
    jobStartDate?: string | undefined;
    jobEndDate?: string | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfQuoteLogSummary {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: QuoteLogSummary[] | undefined;
}

export interface QuoteLogSummary {
    id?: number | undefined;
    submissionDate?: string | undefined;
    action?: QuoteLogSummaryAction | undefined;
    note?: string | undefined;
    createdBy?: string | undefined;
    customer?: CustomerLink | undefined;
    railroad?: RailroadLink | undefined;
    description?: string | undefined;
    jobStart?: string | undefined;
    jobEnd?: string | undefined;
}

export interface QuoteLog {
    id?: number | undefined;
    job?: Job | undefined;
    submissionDate?: string | undefined;
    note?: string | undefined;
    action?: QuoteLogAction | undefined;
}

export interface WeeklyJobShiftsRequest {
    startingSunday?: string | undefined;
    teamId?: number | undefined;
    customerId?: number | undefined;
}

export interface WeeklyJobShiftsResult {
    job?: JobSummary | undefined;
    shifts?: JobShift[] | undefined;
}

export interface BulkAddShiftsRequest {
    jobId?: number | undefined;
    serviceTypeId?: number | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    startTime?: string | undefined;
    countPerDay?: number | undefined;
    sunday?: boolean | undefined;
    monday?: boolean | undefined;
    tuesday?: boolean | undefined;
    wednesday?: boolean | undefined;
    thursday?: boolean | undefined;
    friday?: boolean | undefined;
    saturday?: boolean | undefined;
}

export interface BulkDeleteShiftsRequest {
    jobId?: number | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
}

export interface BulkAssignShiftsRequest {
    ignoreConflicts?: boolean | undefined;
    repeatableShifts?: RepeatableAssignedShiftsRequest[] | undefined;
    unassignedShiftIdsToDelete?: number[] | undefined;
}

export interface RepeatableAssignedShiftsRequest {
    carryThrough?: string | undefined;
    shifts?: JobShift[] | undefined;
}

export interface BulkAssignShiftsResponse {
    rwic?: FieldWorkerLink | undefined;
    conflicts?: ShiftConflictReport[] | undefined;
    assignedShiftsThatWillNotBeDeleted?: JobShift[] | undefined;
}

export interface ShiftConflictReport {
    count?: number | undefined;
    date?: string | undefined;
    jobs?: JobLink[] | undefined;
    unavailableDays?: string | undefined;
}

export interface AddressLink {
    display_name?: string | undefined;
    lat?: number | undefined;
    lon?: number | undefined;
}

export interface JobOptionalFieldsAutocompleteValues {
    workOrderNumber?: string[] | undefined;
    projectNumber?: string[] | undefined;
    projectManagerName?: string[] | undefined;
    agreementNumber?: string[] | undefined;
    upFolderNumber?: string[] | undefined;
    nsActivityNumber?: string[] | undefined;
    referenceNumber?: string[] | undefined;
}

export interface FieldWorkerType {
    id?: number | undefined;
    description?: string | undefined;
    sortOrder?: number | undefined;
}

export interface EmployeeStatus {
    id?: number | undefined;
    description?: string | undefined;
    sortOrder?: number | undefined;
}

export interface AdministratorDetails {
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface NotificationLog {
    id?: number | undefined;
    toPortalUser?: User | undefined;
    toFieldWorker?: FieldWorkerLink | undefined;
    toTeam?: FieldTeamLink | undefined;
    from?: string | undefined;
    title?: string | undefined;
    message?: string | undefined;
    isMessageHtml?: boolean | undefined;
    sentOn?: string | undefined;
    succeeded?: boolean | undefined;
    error?: string | undefined;
    isHidden?: boolean | undefined;
    category?: string | undefined;
    recipients?: NotificationRecipient[] | undefined;
}

export interface User {
    id?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    customer?: Customer | undefined;
    fieldWorker?: FieldWorkerLink | undefined;
    isActive?: boolean | undefined;
    phoneNumber?: string | undefined;
    loginName?: string | undefined;
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    userRegistrationRequestId?: number | undefined;
    setPasswordPath?: string | undefined;
    roles?: string[] | undefined;
}

export interface NotificationRecipient {
    id?: number | undefined;
    name?: string | undefined;
    address?: string | undefined;
}

export interface AdHocNotificationRequest {
    title?: string | undefined;
    body?: string | undefined;
    toFieldWorkerId?: number | undefined;
}

export interface FieldWorkerListArgs {
    statusId?: number | undefined;
    railroadId?: number | undefined;
    customerId?: number | undefined;
    fieldTeamId?: number | undefined;
    unassigned?: boolean | undefined;
    fieldWorkerTypeIds?: number[] | undefined;
    byCertification?: CertificationCriteria | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface CertificationCriteria {
    railroadId?: number | undefined;
    asOfDate?: string | undefined;
}

export interface PagedResultsOfFieldWorker {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: FieldWorker[] | undefined;
}

export interface FieldWorker {
    id?: number | undefined;
    team?: FieldTeamLink | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    jobTitle?: string | undefined;
    type?: FieldWorkerType | undefined;
    status?: EmployeeStatus | undefined;
    employeeCode?: string | undefined;
    paycomId?: string | undefined;
    cityLivedIn?: string | undefined;
    statedLivedIn?: string | undefined;
    perDiemAgreementType?: FieldWorkerPerDiemAgreementType | undefined;
    regularHourlyRate?: number | undefined;
    utilityTravelOverrideRate?: number | undefined;
    isExcludedFromPayroll?: boolean | undefined;
    mealBreakAttestationSigned?: string | undefined;
    payrollType?: FieldWorkerPayrollType | undefined;
    company?: Company | undefined;
    unavailableDays?: FieldWorkerUnavailableDay[] | undefined;
}

export interface FieldWorkerUnavailableDay {
    id?: number | undefined;
    fieldWorker?: FieldWorkerLink | undefined;
    date?: string | undefined;
    reason?: string | undefined;
}

export interface FieldTeamListArgs {
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfFieldTeam {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: FieldTeam[] | undefined;
}

export interface FieldTeam {
    id?: number | undefined;
    fieldManager?: FieldWorkerLink | undefined;
    emailAddress?: string | undefined;
    name?: string | undefined;
    members?: FieldWorkerLink[] | undefined;
}

export interface UserLink {
    id?: string | undefined;
    userId?: string | undefined;
    linkId?: number | undefined;
    linkType: string;
    fullName?: string | undefined;
}

export interface InvoiceSummaryArgs {
    startDate?: string | undefined;
    endDate?: string | undefined;
    railroadIds?: number[] | undefined;
}

export interface InvoiceBundleReportRequest {
    jobIds?: number[] | undefined;
}

export interface Holiday {
    id?: number | undefined;
    date?: string | undefined;
    name?: string | undefined;
}

export interface UserListArgs {
    customerId?: number | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfUser {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: User[] | undefined;
}

export interface PasswordBindingModel {
    email: string;
    token: string;
    newPassword: string;
}

export interface PasswordResetModel {
    email?: string | undefined;
    resetPasswordPath?: string | undefined;
}

export interface ListArgs {
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface Settings {
    id?: number | undefined;
    key?: string | undefined;
    userEmail?: string | undefined;
    value?: string | undefined;
    modified?: string | undefined;
}

export interface UserRegistrationRequestListArgs {
    status?: UserRegistrationRequestListArgsStatus | undefined;
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
}

export interface PagedResultsOfUserRegistrationRequest {
    resultCount?: number | undefined;
    pageNumber?: number | undefined;
    results?: UserRegistrationRequest[] | undefined;
}

export interface UserRegistrationRequest {
    id?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    companyName?: string | undefined;
    phoneNumber?: string | undefined;
    isRegistered?: boolean | undefined;
    isDenied?: boolean | undefined;
    baseUrl?: string | undefined;
    queuePath?: string | undefined;
    applicationUserId?: string | undefined;
}

export enum PayrollType {
    RpfsW2 = "RpfsW2",
    RwtW2 = "RwtW2",
    RpW2 = "RpW2",
    As1099 = "As1099",
    Exempt = "Exempt",
    Subcontractor = "Subcontractor",
}

export enum PayrollBatchPayrollType {
    RpfsW2 = "RpfsW2",
    RwtW2 = "RwtW2",
    RpW2 = "RpW2",
    As1099 = "As1099",
    Exempt = "Exempt",
    Subcontractor = "Subcontractor",
}

export enum PayrollBatchStatus {
    NotStarted = "NotStarted",
    Preparing = "Preparing",
    Submitted = "Submitted",
    Canceled = "Canceled",
    Submitting = "Submitting",
    Generating = "Generating",
    Error = "Error",
}

export enum DwrFormSummaryTypeOfDay {
    BillableDay = "BillableDay",
    ConferenceCall = "ConferenceCall",
    DrugTest = "DrugTest",
    FieldTraining = "FieldTraining",
    JobSetup = "JobSetup",
    RulesClass = "RulesClass",
    TerritoryQualification = "TerritoryQualification",
    Travel = "Travel",
    Other = "Other",
}

export enum PaycheckCandidateStatus {
    NotStarted = "NotStarted",
    Preparing = "Preparing",
    Submitted = "Submitted",
    Canceled = "Canceled",
    Submitting = "Submitting",
    Generating = "Generating",
    Error = "Error",
}

export enum PaycheckCandidateWorkerPayrollType {
    RpfsW2 = "RpfsW2",
    RwtW2 = "RwtW2",
    RpW2 = "RpW2",
    As1099 = "As1099",
    Exempt = "Exempt",
    Subcontractor = "Subcontractor",
}

export enum FieldWorkerLinkPayrollType {
    RpfsW2 = "RpfsW2",
    RwtW2 = "RwtW2",
    RpW2 = "RpW2",
    As1099 = "As1099",
    Exempt = "Exempt",
    Subcontractor = "Subcontractor",
}

export enum ServiceTypeTravelTimeCalculationType {
    NotSet = "NotSet",
    Regular = "Regular",
    Halved = "Halved",
}

export enum PaycheckLineItemType {
    FlaggingHours = "FlaggingHours",
    OtherNonFlaggingHours = "OtherNonFlaggingHours",
    MealBonus = "MealBonus",
    TravelCommute = "TravelCommute",
    TravelPaid = "TravelPaid",
    Nonpayable = "Nonpayable",
    MileageReimbursement = "MileageReimbursement",
    PerDiemMeal = "PerDiemMeal",
    CellPhoneReimbursement = "CellPhoneReimbursement",
    PerDiemHotel = "PerDiemHotel",
    ConferenceCall = "ConferenceCall",
    NewHireTraining = "NewHireTraining",
    DrugTesting = "DrugTesting",
    ContinuingTraining = "ContinuingTraining",
    PpeReimbursement = "PpeReimbursement",
    PaidTimeOff = "PaidTimeOff",
    Holiday = "Holiday",
    GuaranteedHours = "GuaranteedHours",
    JuryDuty = "JuryDuty",
    Bereavement = "Bereavement",
    Sick = "Sick",
    PerformTraining = "PerformTraining",
    FloatingHoliday = "FloatingHoliday",
}

export enum PaycheckLineItemPrevailingWageApplication {
    NotApplicable = "NotApplicable",
    IsPrevailingWage = "IsPrevailingWage",
    IsNotPrevailingWage = "IsNotPrevailingWage",
    RegularWageIsHigher = "RegularWageIsHigher",
}

export enum PaycheckLineItemRateType {
    NotApplicable = "NotApplicable",
    Regular = "Regular",
    OverTime = "OverTime",
    DoubleTime = "DoubleTime",
    PrevailingWage1 = "PrevailingWage1",
    PrevailingWage2 = "PrevailingWage2",
    PrevailingWage3 = "PrevailingWage3",
}

export enum PaycheckCandidateSummaryStatus {
    NotStarted = "NotStarted",
    Preparing = "Preparing",
    Submitted = "Submitted",
    Canceled = "Canceled",
    Submitting = "Submitting",
    Generating = "Generating",
    Error = "Error",
}

export enum PaycheckCandidateSummaryPayrollType {
    RpfsW2 = "RpfsW2",
    RwtW2 = "RwtW2",
    RpW2 = "RpW2",
    As1099 = "As1099",
    Exempt = "Exempt",
    Subcontractor = "Subcontractor",
}

export enum PaycheckCandidateSummaryWorkerPayrollType {
    RpfsW2 = "RpfsW2",
    RwtW2 = "RwtW2",
    RpW2 = "RpW2",
    As1099 = "As1099",
    Exempt = "Exempt",
    Subcontractor = "Subcontractor",
}

export enum PayrollBatchListArgsPayrollType {
    RpfsW2 = "RpfsW2",
    RwtW2 = "RwtW2",
    RpW2 = "RpW2",
    As1099 = "As1099",
    Exempt = "Exempt",
    Subcontractor = "Subcontractor",
}

export enum ItemStatuses {
    NotStarted = "NotStarted",
    Preparing = "Preparing",
    Submitted = "Submitted",
    Canceled = "Canceled",
    Submitting = "Submitting",
    Generating = "Generating",
    Error = "Error",
}

export enum PayrollBatchGroupStatus {
    NotStarted = "NotStarted",
    Preparing = "Preparing",
    PartiallySubmitted = "PartiallySubmitted",
    FullySubmitted = "FullySubmitted",
}

export enum PayrollBatchSummaryPayrollType {
    RpfsW2 = "RpfsW2",
    RwtW2 = "RwtW2",
    RpW2 = "RpW2",
    As1099 = "As1099",
    Exempt = "Exempt",
    Subcontractor = "Subcontractor",
}

export enum PayrollBatchSummaryStatus {
    NotStarted = "NotStarted",
    Preparing = "Preparing",
    Submitted = "Submitted",
    Canceled = "Canceled",
    Submitting = "Submitting",
    Generating = "Generating",
    Error = "Error",
}

export enum PaycheckCandidateListArgsPayrollType {
    RpfsW2 = "RpfsW2",
    RwtW2 = "RwtW2",
    RpW2 = "RpW2",
    As1099 = "As1099",
    Exempt = "Exempt",
    Subcontractor = "Subcontractor",
}

export enum PaycheckStatuses {
    NotStarted = "NotStarted",
    Preparing = "Preparing",
    Submitted = "Submitted",
    Canceled = "Canceled",
    Submitting = "Submitting",
    Generating = "Generating",
    Error = "Error",
}

export enum PayrollBatchRefreshRequestPayrollType {
    RpfsW2 = "RpfsW2",
    RwtW2 = "RwtW2",
    RpW2 = "RpW2",
    As1099 = "As1099",
    Exempt = "Exempt",
    Subcontractor = "Subcontractor",
}

export enum InvoiceStatuses {
    NotStarted = "NotStarted",
    Preparing = "Preparing",
    Submitted = "Submitted",
    Canceled = "Canceled",
    Submitting = "Submitting",
    Generating = "Generating",
    Error = "Error",
}

export enum InvoiceCandidateSummaryStatus {
    NotStarted = "NotStarted",
    Preparing = "Preparing",
    Submitted = "Submitted",
    Canceled = "Canceled",
    Submitting = "Submitting",
    Generating = "Generating",
    Error = "Error",
}

export enum InvoiceCandidateStatus {
    NotStarted = "NotStarted",
    Preparing = "Preparing",
    Submitted = "Submitted",
    Canceled = "Canceled",
    Submitting = "Submitting",
    Generating = "Generating",
    Error = "Error",
}

export enum InvoiceCandidatePreferredBillingChannel {
    Email = "Email",
    Mail = "Mail",
    Portal = "Portal",
}

export enum InvoiceLineItemType {
    RegularShift = "RegularShift",
    HolidayShift = "HolidayShift",
    WeekendShift = "WeekendShift",
    NightShift = "NightShift",
    OvertimeHour = "OvertimeHour",
    InitialMobilizationFee = "InitialMobilizationFee",
    RemobilizationFee = "RemobilizationFee",
    DemobilizationFee = "DemobilizationFee",
    DailyMileageFee = "DailyMileageFee",
    PerDiem = "PerDiem",
    CertifiedPayrollFee = "CertifiedPayrollFee",
    ProcessAndHandlingFee = "ProcessAndHandlingFee",
    ExpeditedServiceFee = "ExpeditedServiceFee",
    ActualMileageCharges = "ActualMileageCharges",
    VehicleFee = "VehicleFee",
    HolidayOvertimeHour = "HolidayOvertimeHour",
    WeekendOvertimeHour = "WeekendOvertimeHour",
    NightOvertimeHour = "NightOvertimeHour",
    OtherChargeItem = "OtherChargeItem",
    RegularHour = "RegularHour",
    StandDownDay = "StandDownDay",
    UnderschedulingFee = "UnderschedulingFee",
    RailroadAdministrationFee = "RailroadAdministrationFee",
}

export enum UtilityCoverSheetStatusResponseStatus {
    NotNeeded = "NotNeeded",
    ReadyForInvoicing = "ReadyForInvoicing",
    MissingApprovedCoverSheet = "MissingApprovedCoverSheet",
    MoreThanOneCoverSheet = "MoreThanOneCoverSheet",
    WaitingForJobToBeCompleted = "WaitingForJobToBeCompleted",
    WaitingForApproval = "WaitingForApproval",
}

export enum ResolutionTypes {
    InsertAutoApproved = "InsertAutoApproved",
    UpdateAutoApproved = "UpdateAutoApproved",
    UpdateManualPending = "UpdateManualPending",
    Failed = "Failed",
    Approved = "Approved",
    Rejected = "Rejected",
}

export enum ApiRequestResolution {
    InsertAutoApproved = "InsertAutoApproved",
    UpdateAutoApproved = "UpdateAutoApproved",
    UpdateManualPending = "UpdateManualPending",
    Failed = "Failed",
    Approved = "Approved",
    Rejected = "Rejected",
}

export enum AuditTrailEventType {
    Update = "Update",
    Delete = "Delete",
}

export enum RailroadPublicDwrStyle {
    Style1 = "Style1",
    Style2 = "Style2",
}

export enum RailroadDwrType {
    StandardFlaggingDwr = "StandardFlaggingDwr",
    CsxDwr = "CsxDwr",
    UpDwr = "UpDwr",
    CnDwr = "CnDwr",
    WmataDwr = "WmataDwr",
    ScrraDwr = "ScrraDwr",
    StandardMonitoringDwr = "StandardMonitoringDwr",
    KcsDwr = "KcsDwr",
    HighwayProtectorDwr = "HighwayProtectorDwr",
    CpDwr = "CpDwr",
    CsxCicDwr = "CsxCicDwr",
    TriMet = "TriMet",
}

export enum RailroadOvertimeBasis {
    Daily = "Daily",
    Weekly = "Weekly",
}

export enum RailroadRegularTimeBasis {
    Daily = "Daily",
    Hourly = "Hourly",
}

export enum RailroadClass {
    I = "I",
    II = "II",
    III = "III",
    RegionalCommuterCarrier = "RegionalCommuterCarrier",
    RapidTransit = "RapidTransit",
}

export enum DivisionStatus {
    Active = "Active",
    Inactive = "Inactive",
}

export enum SubdivisionStatus {
    Active = "Active",
    Inactive = "Inactive",
}

export enum DayClassifications {
    BillableDay = "BillableDay",
    ConferenceCall = "ConferenceCall",
    DrugTest = "DrugTest",
    FieldTraining = "FieldTraining",
    JobSetup = "JobSetup",
    RulesClass = "RulesClass",
    TerritoryQualification = "TerritoryQualification",
    Travel = "Travel",
    Other = "Other",
}

export enum PayrollTypes {
    RpfsW2 = "RpfsW2",
    RwtW2 = "RwtW2",
    RpW2 = "RpW2",
    As1099 = "As1099",
    Exempt = "Exempt",
    Subcontractor = "Subcontractor",
}

export enum DwrFormTypeOfDay {
    BillableDay = "BillableDay",
    ConferenceCall = "ConferenceCall",
    DrugTest = "DrugTest",
    FieldTraining = "FieldTraining",
    JobSetup = "JobSetup",
    RulesClass = "RulesClass",
    TerritoryQualification = "TerritoryQualification",
    Travel = "Travel",
    Other = "Other",
}

export enum DwrFormNonBillableDayReason {
    HoldOver = "HoldOver",
    Shadowing = "Shadowing",
    Equipment = "Equipment",
    NoProtection = "NoProtection",
    OpportunityLoss = "OpportunityLoss",
    PaidTimeOff = "PaidTimeOff",
    Holiday = "Holiday",
    JuryDuty = "JuryDuty",
    Bereavement = "Bereavement",
    Sick = "Sick",
    TravelMobilization = "TravelMobilization",
    FloatingHoliday = "FloatingHoliday",
}

export enum FormFieldResponseIsLockedStatus {
    Never = "Never",
    Always = "Always",
    PreApproval = "PreApproval",
}

export enum FormFieldResponseType {
    UserInput = "UserInput",
    PickOne = "PickOne",
    PickMany = "PickMany",
    FormHeader = "FormHeader",
    Audit = "Audit",
    Date = "Date",
    Time = "Time",
    DateTime = "DateTime",
    Integer = "Integer",
    Decimal2 = "Decimal2",
    YesNo = "YesNo",
    Signature = "Signature",
    Photo = "Photo",
    DB_JobNumber_readonly = "DB_JobNumber_readonly",
    DB_RailroadCode_readonly = "DB_RailroadCode_readonly",
    DB_RwicName_readonly = "DB_RwicName_readonly",
    DB_RwicEmployeeCode_readonly = "DB_RwicEmployeeCode_readonly",
    DB_CustomerCompanyName_readonly = "DB_CustomerCompanyName_readonly",
    DB_PointOfContactName_editable = "DB_PointOfContactName_editable",
    DB_PointOfContactPhone_editable = "DB_PointOfContactPhone_editable",
    DB_JobDivision_editable = "DB_JobDivision_editable",
    DB_JobSubdivision_editable = "DB_JobSubdivision_editable",
    DB_JobStartDate_editable = "DB_JobStartDate_editable",
    DB_JobDuration_editable = "DB_JobDuration_editable",
    DB_JobDescription_editable = "DB_JobDescription_editable",
    DB_JobMilePost_editable = "DB_JobMilePost_editable",
    Phone = "Phone",
    PhoneOnly = "PhoneOnly",
    RealList = "RealList",
    Number99 = "Number99",
    Number999 = "Number999",
    MultiLine = "MultiLine",
    FormSubHeader = "FormSubHeader",
    GpsCoordinates = "GpsCoordinates",
    Optional = "Optional",
    UserInputAllFirstCapital = "UserInputAllFirstCapital",
    Select = "Select",
    Checkbox = "Checkbox",
    FieldArray = "FieldArray",
    DatePicker = "DatePicker",
    TimePicker = "TimePicker",
    Header = "Header",
    MultiSelect = "MultiSelect",
    PlainText = "PlainText",
    Radio = "Radio",
    Slider = "Slider",
    Switch = "Switch",
    Tabs = "Tabs",
    TextArea = "TextArea",
    TextField = "TextField",
    PhoneNumber = "PhoneNumber",
    EmailAddress = "EmailAddress",
    TextField40CharacterLimit = "TextField40CharacterLimit",
    CostCenterPicker = "CostCenterPicker",
    StationNumberPicker = "StationNumberPicker",
    OdometerCapture = "OdometerCapture",
    MaintenanceOfWayLog = "MaintenanceOfWayLog",
    CsxProvidedProtectionsLog = "CsxProvidedProtectionsLog",
    DailyActivityLog = "DailyActivityLog",
}

export enum OdometerCaptureCaptureStatus {
    Queued = "Queued",
    Processing = "Processing",
    Succeeded = "Succeeded",
    Failed = "Failed",
    CorrectedManually = "CorrectedManually",
}

export enum OdometerCaptureCaptureKind {
    StartOfDay = "StartOfDay",
    EndOfDay = "EndOfDay",
}

export enum OdometerCaptureCaptureSource {
    OpenAi = "OpenAi",
}

export enum JobSummaryStatus {
    CustomerEntry = "CustomerEntry",
    Submitted = "Submitted",
    Reviewing = "Reviewing",
    Approved = "Approved",
    InProgress = "InProgress",
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export enum JobSummaryQuoteStatus {
    NeedsApproval = "NeedsApproval",
    NeedsPaperwork = "NeedsPaperwork",
    NeedsProtection = "NeedsProtection",
    SentToDTM1 = "SentToDTM1",
    SentToDTM2 = "SentToDTM2",
    SentToDTM3 = "SentToDTM3",
    SentToMIPP1 = "SentToMIPP1",
    SentToMIPP2 = "SentToMIPP2",
    SentToMIPP3 = "SentToMIPP3",
    NoResponse = "NoResponse",
}

export enum JobSummaryTrackID {
    Main = "Main",
    OtherThanMain = "OtherThanMain",
    MainSiding = "MainSiding",
}

export enum DwrDataDrivenFormViewModelTypeOfDay {
    BillableDay = "BillableDay",
    ConferenceCall = "ConferenceCall",
    DrugTest = "DrugTest",
    FieldTraining = "FieldTraining",
    JobSetup = "JobSetup",
    RulesClass = "RulesClass",
    TerritoryQualification = "TerritoryQualification",
    Travel = "Travel",
    Other = "Other",
}

export enum DwrDataDrivenFormViewModelNonBillableDayReason {
    HoldOver = "HoldOver",
    Shadowing = "Shadowing",
    Equipment = "Equipment",
    NoProtection = "NoProtection",
    OpportunityLoss = "OpportunityLoss",
    PaidTimeOff = "PaidTimeOff",
    Holiday = "Holiday",
    JuryDuty = "JuryDuty",
    Bereavement = "Bereavement",
    Sick = "Sick",
    TravelMobilization = "TravelMobilization",
    FloatingHoliday = "FloatingHoliday",
}

export enum DwrSubmissionViewModelTypeOfDay {
    BillableDay = "BillableDay",
    ConferenceCall = "ConferenceCall",
    DrugTest = "DrugTest",
    FieldTraining = "FieldTraining",
    JobSetup = "JobSetup",
    RulesClass = "RulesClass",
    TerritoryQualification = "TerritoryQualification",
    Travel = "Travel",
    Other = "Other",
}

export enum DwrSubmissionViewModelNonBillableReason {
    HoldOver = "HoldOver",
    Shadowing = "Shadowing",
    Equipment = "Equipment",
    NoProtection = "NoProtection",
    OpportunityLoss = "OpportunityLoss",
    PaidTimeOff = "PaidTimeOff",
    Holiday = "Holiday",
    JuryDuty = "JuryDuty",
    Bereavement = "Bereavement",
    Sick = "Sick",
    TravelMobilization = "TravelMobilization",
    FloatingHoliday = "FloatingHoliday",
}

export enum DwrDayClassificationViewModelTypeOfDay {
    BillableDay = "BillableDay",
    ConferenceCall = "ConferenceCall",
    DrugTest = "DrugTest",
    FieldTraining = "FieldTraining",
    JobSetup = "JobSetup",
    RulesClass = "RulesClass",
    TerritoryQualification = "TerritoryQualification",
    Travel = "Travel",
    Other = "Other",
}

export enum NonbillableReasonViewModelReason {
    HoldOver = "HoldOver",
    Shadowing = "Shadowing",
    Equipment = "Equipment",
    NoProtection = "NoProtection",
    OpportunityLoss = "OpportunityLoss",
    PaidTimeOff = "PaidTimeOff",
    Holiday = "Holiday",
    JuryDuty = "JuryDuty",
    Bereavement = "Bereavement",
    Sick = "Sick",
    TravelMobilization = "TravelMobilization",
    FloatingHoliday = "FloatingHoliday",
}

export enum SectionType {
    NoSection = "NoSection",
    ProjectInformation = "ProjectInformation",
    Property = "Property",
    WorkZoneInformation = "WorkZoneInformation",
    Description = "Description",
    TimeAndTravel = "TimeAndTravel",
    Signatures = "Signatures",
}

export enum SectionHeaderType {
    UserInput = "UserInput",
    PickOne = "PickOne",
    PickMany = "PickMany",
    FormHeader = "FormHeader",
    Audit = "Audit",
    Date = "Date",
    Time = "Time",
    DateTime = "DateTime",
    Integer = "Integer",
    Decimal2 = "Decimal2",
    YesNo = "YesNo",
    Signature = "Signature",
    Photo = "Photo",
    DB_JobNumber_readonly = "DB_JobNumber_readonly",
    DB_RailroadCode_readonly = "DB_RailroadCode_readonly",
    DB_RwicName_readonly = "DB_RwicName_readonly",
    DB_RwicEmployeeCode_readonly = "DB_RwicEmployeeCode_readonly",
    DB_CustomerCompanyName_readonly = "DB_CustomerCompanyName_readonly",
    DB_PointOfContactName_editable = "DB_PointOfContactName_editable",
    DB_PointOfContactPhone_editable = "DB_PointOfContactPhone_editable",
    DB_JobDivision_editable = "DB_JobDivision_editable",
    DB_JobSubdivision_editable = "DB_JobSubdivision_editable",
    DB_JobStartDate_editable = "DB_JobStartDate_editable",
    DB_JobDuration_editable = "DB_JobDuration_editable",
    DB_JobDescription_editable = "DB_JobDescription_editable",
    DB_JobMilePost_editable = "DB_JobMilePost_editable",
    Phone = "Phone",
    PhoneOnly = "PhoneOnly",
    RealList = "RealList",
    Number99 = "Number99",
    Number999 = "Number999",
    MultiLine = "MultiLine",
    FormSubHeader = "FormSubHeader",
    GpsCoordinates = "GpsCoordinates",
    Optional = "Optional",
    UserInputAllFirstCapital = "UserInputAllFirstCapital",
    Select = "Select",
    Checkbox = "Checkbox",
    FieldArray = "FieldArray",
    DatePicker = "DatePicker",
    TimePicker = "TimePicker",
    Header = "Header",
    MultiSelect = "MultiSelect",
    PlainText = "PlainText",
    Radio = "Radio",
    Slider = "Slider",
    Switch = "Switch",
    Tabs = "Tabs",
    TextArea = "TextArea",
    TextField = "TextField",
    PhoneNumber = "PhoneNumber",
    EmailAddress = "EmailAddress",
    TextField40CharacterLimit = "TextField40CharacterLimit",
    CostCenterPicker = "CostCenterPicker",
    StationNumberPicker = "StationNumberPicker",
    OdometerCapture = "OdometerCapture",
    MaintenanceOfWayLog = "MaintenanceOfWayLog",
    CsxProvidedProtectionsLog = "CsxProvidedProtectionsLog",
    DailyActivityLog = "DailyActivityLog",
}

export enum FormFieldType {
    UserInput = "UserInput",
    PickOne = "PickOne",
    PickMany = "PickMany",
    FormHeader = "FormHeader",
    Audit = "Audit",
    Date = "Date",
    Time = "Time",
    DateTime = "DateTime",
    Integer = "Integer",
    Decimal2 = "Decimal2",
    YesNo = "YesNo",
    Signature = "Signature",
    Photo = "Photo",
    DB_JobNumber_readonly = "DB_JobNumber_readonly",
    DB_RailroadCode_readonly = "DB_RailroadCode_readonly",
    DB_RwicName_readonly = "DB_RwicName_readonly",
    DB_RwicEmployeeCode_readonly = "DB_RwicEmployeeCode_readonly",
    DB_CustomerCompanyName_readonly = "DB_CustomerCompanyName_readonly",
    DB_PointOfContactName_editable = "DB_PointOfContactName_editable",
    DB_PointOfContactPhone_editable = "DB_PointOfContactPhone_editable",
    DB_JobDivision_editable = "DB_JobDivision_editable",
    DB_JobSubdivision_editable = "DB_JobSubdivision_editable",
    DB_JobStartDate_editable = "DB_JobStartDate_editable",
    DB_JobDuration_editable = "DB_JobDuration_editable",
    DB_JobDescription_editable = "DB_JobDescription_editable",
    DB_JobMilePost_editable = "DB_JobMilePost_editable",
    Phone = "Phone",
    PhoneOnly = "PhoneOnly",
    RealList = "RealList",
    Number99 = "Number99",
    Number999 = "Number999",
    MultiLine = "MultiLine",
    FormSubHeader = "FormSubHeader",
    GpsCoordinates = "GpsCoordinates",
    Optional = "Optional",
    UserInputAllFirstCapital = "UserInputAllFirstCapital",
    Select = "Select",
    Checkbox = "Checkbox",
    FieldArray = "FieldArray",
    DatePicker = "DatePicker",
    TimePicker = "TimePicker",
    Header = "Header",
    MultiSelect = "MultiSelect",
    PlainText = "PlainText",
    Radio = "Radio",
    Slider = "Slider",
    Switch = "Switch",
    Tabs = "Tabs",
    TextArea = "TextArea",
    TextField = "TextField",
    PhoneNumber = "PhoneNumber",
    EmailAddress = "EmailAddress",
    TextField40CharacterLimit = "TextField40CharacterLimit",
    CostCenterPicker = "CostCenterPicker",
    StationNumberPicker = "StationNumberPicker",
    OdometerCapture = "OdometerCapture",
    MaintenanceOfWayLog = "MaintenanceOfWayLog",
    CsxProvidedProtectionsLog = "CsxProvidedProtectionsLog",
    DailyActivityLog = "DailyActivityLog",
}

export enum FormSectionSectionType {
    Default = "Default",
}

export enum Statuses {
    Submitted = "Submitted",
    Pass = "Pass",
    PassWithException = "PassWithException",
    Fail = "Fail",
    Expired = "Expired",
}

export enum FlashAuditSummaryStatus {
    Submitted = "Submitted",
    Pass = "Pass",
    PassWithException = "PassWithException",
    Fail = "Fail",
    Expired = "Expired",
}

export enum FlashAuditStatus {
    Submitted = "Submitted",
    Pass = "Pass",
    PassWithException = "PassWithException",
    Fail = "Fail",
    Expired = "Expired",
}

export enum JobStatuses {
    CustomerEntry = "CustomerEntry",
    Submitted = "Submitted",
    Reviewing = "Reviewing",
    Approved = "Approved",
    InProgress = "InProgress",
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export enum JobListArgsBillingStatus {
    NotReady = "NotReady",
    Queued = "Queued",
    SubmittedForInvoicing = "SubmittedForInvoicing",
}

export enum JobListArgsPayrollStatus {
    NotReady = "NotReady",
    Queued = "Queued",
    PoSent = "PoSent",
    SubmittedForPayment1099 = "SubmittedForPayment1099",
    SubmittedForPaymentW2 = "SubmittedForPaymentW2",
}

export enum JobListArgsQuoteStatus {
    NeedsApproval = "NeedsApproval",
    NeedsPaperwork = "NeedsPaperwork",
    NeedsProtection = "NeedsProtection",
    SentToDTM1 = "SentToDTM1",
    SentToDTM2 = "SentToDTM2",
    SentToDTM3 = "SentToDTM3",
    SentToMIPP1 = "SentToMIPP1",
    SentToMIPP2 = "SentToMIPP2",
    SentToMIPP3 = "SentToMIPP3",
    NoResponse = "NoResponse",
}

export enum BillableJobSummaryStatus {
    CustomerEntry = "CustomerEntry",
    Submitted = "Submitted",
    Reviewing = "Reviewing",
    Approved = "Approved",
    InProgress = "InProgress",
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export enum JobTrackID {
    Main = "Main",
    OtherThanMain = "OtherThanMain",
    MainSiding = "MainSiding",
}

export enum JobStatus {
    CustomerEntry = "CustomerEntry",
    Submitted = "Submitted",
    Reviewing = "Reviewing",
    Approved = "Approved",
    InProgress = "InProgress",
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export enum JobQuoteStatus {
    NeedsApproval = "NeedsApproval",
    NeedsPaperwork = "NeedsPaperwork",
    NeedsProtection = "NeedsProtection",
    SentToDTM1 = "SentToDTM1",
    SentToDTM2 = "SentToDTM2",
    SentToDTM3 = "SentToDTM3",
    SentToMIPP1 = "SentToMIPP1",
    SentToMIPP2 = "SentToMIPP2",
    SentToMIPP3 = "SentToMIPP3",
    NoResponse = "NoResponse",
}

export enum JobPreferredBillingChannel {
    Email = "Email",
    Mail = "Mail",
    Portal = "Portal",
}

export enum JobBillTo {
    Customer = "Customer",
    Railroad = "Railroad",
    Other = "Other",
}

export enum JobOverTimeBasis {
    Daily = "Daily",
    Weekly = "Weekly",
}

export enum JobRegularTimeBasis {
    Daily = "Daily",
    Hourly = "Hourly",
}

export enum JobParty {
    First = "First",
    Third = "Third",
    Passthrough = "Passthrough",
}

export enum JobType {
    New = "New",
    MaintenanceOrUpgrade = "MaintenanceOrUpgrade",
}

export enum JobEndMarket {
    Electric = "Electric",
    FiberAndCable = "FiberAndCable",
    WaterAndWastewater = "WaterAndWastewater",
    OilAndGas = "OilAndGas",
    VegetationMgmt = "VegetationMgmt",
    RoadAndBridge = "RoadAndBridge",
    Other = "Other",
}

export enum JobNetworkOrServiceOrder {
    NotApplicable = "NotApplicable",
    Network = "Network",
    ServiceOrder = "ServiceOrder",
}

export enum JobSummaryMobileTrackID {
    Main = "Main",
    OtherThanMain = "OtherThanMain",
    MainSiding = "MainSiding",
}

export enum Actions {
    CustomerSubmission = "CustomerSubmission",
    CustomerComment = "CustomerComment",
    EstimateToCustomer = "EstimateToCustomer",
    CommentToCustomer = "CommentToCustomer",
    CustomerApproval = "CustomerApproval",
    RailProsApproval = "RailProsApproval",
    Cancellation = "Cancellation",
    Revision = "Revision",
    Creation = "Creation",
}

export enum QuoteLogSummaryAction {
    CustomerSubmission = "CustomerSubmission",
    CustomerComment = "CustomerComment",
    EstimateToCustomer = "EstimateToCustomer",
    CommentToCustomer = "CommentToCustomer",
    CustomerApproval = "CustomerApproval",
    RailProsApproval = "RailProsApproval",
    Cancellation = "Cancellation",
    Revision = "Revision",
    Creation = "Creation",
}

export enum QuoteLogAction {
    CustomerSubmission = "CustomerSubmission",
    CustomerComment = "CustomerComment",
    EstimateToCustomer = "EstimateToCustomer",
    CommentToCustomer = "CommentToCustomer",
    CustomerApproval = "CustomerApproval",
    RailProsApproval = "RailProsApproval",
    Cancellation = "Cancellation",
    Revision = "Revision",
    Creation = "Creation",
}

export enum FieldWorkerPerDiemAgreementType {
    A = "A",
    B = "B",
}

export enum FieldWorkerPayrollType {
    RpfsW2 = "RpfsW2",
    RwtW2 = "RwtW2",
    RpW2 = "RpW2",
    As1099 = "As1099",
    Exempt = "Exempt",
    Subcontractor = "Subcontractor",
}

export enum UserRegistrationRequestListArgsStatus {
    Pending = "Pending",
    Registered = "Registered",
    Denied = "Denied",
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}